var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSiemu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 850,
    height: 720,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 321,
    height: 281,
    xlinkHref: "data:image/png;base64,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",
    preserveAspectRatio: "none",
    id: "img0"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 229,
    y: 7,
    width: 321,
    height: 281
  })), /*#__PURE__*/React.createElement("image", {
    width: 670,
    height: 537,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAp4AAAIZCAMAAAA4Hc/BAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAzUExURQAAAAAzZggxWgYyWQgxVgcyWQgxWgcyWgYyWQcyWwcyWggyWwcyWggzWQcyWggyWQcyWmmW84wAAAARdFJOUwAPHy4+TV1se4qZqbjI1+f22mfbWgAAAAlwSFlzAAAOwwAADsMBx2+oZAAAFeJJREFUeF7t3euCmjoUQOECoqAi5/2f9hDczMVJBDUhe8P6fnXaaQdhlTvhXwrFg/Kb/I6Q7wdeMqRTllVVHQ51XR+Px9OgadrBeXC5XK6DzrmN+tF/b7v//fu/5f5V988PP+XiflrbHmWqsE/VUJ0rztX2UWaptKVMKfbnoDDIRyeZVuzNyUCd//13lanFvjSy/LWjzz06y9LXj+37Dsmyt4Djo90pZNFbwAmm3Sll0VvA1n13yBOKVbLoLSDP3bGUZyPTjN0gTyh2kEVvQSvTjN2wlOdZphm7QZ5QrJZFb8FFphm7QZ5Q7CiL3gLy3B1LeXJL3e6QJxQ7yaK3oJNpxm6QJxQjTyhmKc+bTDN2w8qDcA557g55QjHyhGKW8uxlmrEbrSx6C8hzd8gTipEnFCNPKEaeUMzOCGDkuUPkCcXIE4qRJxQjTyhGnlCMPKEYeUIx8oRi5AnFyBOKkScUI08oZilPnjXaHVNrz7LkxXD7YilP5yDTjV0gTyhm6W55hzx3hTyhGHlCMWt5ng5x1UHyDYfKKZ2iKGSuYSXW8lSg7/vb7dZ13aU9cqIrLfL8TN/WMieRgLU8r5fzXeslf3gZXJ1hHTes6W59L389iZZ1aCqWRqhzPjk0KoqyrKpxf/N4PDVNM9V8J4X/+k3X+T3079I9qZ8JNI095RmTS/1wushU8bbkRMjzM/V02a1jBZoAeX5M3h7Rc0o2Pktv5nA0NlDIGpQ+o7OUZz8ct1Qy3brcX/3Y65w4y0zlKdOsUDUeznO/dGyWXvmq+WGOe5+80jsy8ozkME4im/e4yDOW8fobr/2Mqx4XvA3Kn9S8uWnk7GdU5BnNOCvP8gWiIM943OpT+zQac9+jt0H7oh/34zk3HxN5xlO4iWzkC8RQjQveBvUbTrd159RnTOQZkTu3xM5nTOV9yZugfsmPO588LhcReUZEnrGNu/NG2MiTE/MRkWdE40lk8oyIPCMa8+SukJjGBW8Dee7PuOBtIM/9STpAQVzqb0YfL8GRZ0zkGc+YJxfdYxrvUrSBPPenG5e8CeS5P4byVP+kxHgDA3nGdB2XvAk28mRAxZjIMx7yjO57kDX1rjLJapFndIZebKQ+z/H2L/KMydDwyDbyPMoXiMFQnuqfkyDP6AwN8Kn+GXLyjI484xnvTiTPmAwNsmQjz5N8gRgMDROi/vUC5BkdecZDntEZGiZE/QAc5BmdoXEY9C94G1NpiaEH3fUfE7upJM+Yxg2SDTbyZAywmAzlqf9qtptK8oxqXPIW9PqHh3GTSZ5RmXkWzsByd/OSPKOy8ixcZ2BsLfKMrrTxtJGJNwKSZ3yFhec5bLyP2uXJm91jU/9izf5kY9RM8kyiVP1IR9dYGZSQPJMpirIsq6o6HA714OicnGbSeskfvkX+CTH+1vgjj8dhCg6HYWrKojA03DB5QjF3FoQ8oRR5QjGXJ2/VhFLkCcXIE4qRJxQjTyhGnlDM3V1DnlCKPKEYeUIxl6f6cfSwV+QJxcgTipEnFCNPKEaeUIw8oRh5QjHyhGLkCcXIE4qRJxQjTyjmRqsiTyhFnlCMPKEYeUIx8oRi5AnFyBOKkScUI08oRp5QjIuaUIw8oRh5QjHyhGLkCcXIE4qRJxQjTyhGnlCMPKEYeUIx8oRiLk/GlodS5AnFyBOK8VY4LFfU53X1Q543+fW8tm2a5nQ6Ho91XR8GVVUOiqKQ6ceGFa2rxay+72+Druuug4tzb3owZO3CHgxtO0PfjmvcqSalzAtoU7gnK3avkbkBXQp3mAJ2hXVqZPHsHutPjdxBNAatzBAoUsnCAXkqdJSFA/JU6CQLBxwbKUSeE/JUiDwn5KkQeU7IUyHynJCnQuQ54e59hchzQp4KkeeEPBUizwl5KkSeE/JUiDwn5KkQeU6uMkegCHlOyFMh8pyQp0LkOSFPbcqy5FmOCXlqw1NwP3QyU6AFef5AntqQ5w/kqQ15/kCeryqq6j7kSqJBVsjzB/J8QXVqu19DH90u52YcHyginnH/gTyXOrSs11Z3k5mPp4oTbeZAnkt8b3H7W3cfDPByvabZDJseODE28pxXXe7z6tpUj2OrlvVJ/jCO/nwq5ZcYkOesw7g+65tKvn4Qc8SZqzsZwLHRN/Kcc3J19qfgmNQR799oxx/CyLPfyHPGWN/5yYDp8TbuMt7VWb4Eec5xdd5q+cIr2rZ4GmqVPL/1Mk/g5fY7xx3CoGhjcX4NBEye38jzmcLV+fxNKLF2Pb9HsqybhkIFeT4zZNI9rzPWgczvcVZr+d3dI88nhkr6mfs+DjIfP/SwiiZPQZ5PDGvGk/wyJM5m+Pawio4UvX3kGTasw+aedYnTUf94aoA8BXmGDSvPp6eUhsP2OBfI/7y9hzwFeQYNjczcbljGOef59+iLPCcyQ/BHO/fekirSGfmD/HvfeLHRRGYIHhVDfE+37ZG27L7/A+Q5kRmCR+7kzrNznsdIdfaeH0KeE5kheNQ83fUshk1/HL63mpLnRGYIHg3b9vBppUO0Zzt8K0/y/CIzBA+KYd6EBj8to606A6+EJs+JzBA8cOd2/G/VKdtIe52O/6IpeU5khuCBuxPJs/YsDteIcYZW0OQ5kRmCB+5i+mM71ekStc2B/9QVeU6enTvZs/FGucu5OR7rw6GuT48DhMThPTAiz2/k6bfOA2mBd0aS54Q8/dbJM3DVlDwn5Om3Tp6Bq6bkOSFPv3Xy/Hs3yIg8J+Tpt06egUdFyHNCnn7kqQJ5+q2TZ2DuczvyhDz91slTftgj8pyQpx9rTxXI0488VZgZZmC3Xsmzf3vYhMCYoeQ5IU+/F/Lsj28PUxcY5YFRQibk6fdCnm1Vvrsr4L0ZmTy/kaffOvuegfvxYw4Ibht5+q2TZ2AUDPKckKffOnkGZj95TsjTb6U8/cdGEV+nYBx5+q2Up3/rTp4T8vRbKU///CfPCXn6rZWn93GORv4Q5Om3Vp7eBUCeE/L0Wy1P3+oz4igkxpGn32p5+pYAeU7I02+9PD1Xjniv0YQ8/dbL0/O4JnlOyNNvxTz/DhUS9R3xppGn34p5/h1HlDwn5Om3Zp5/Lm2u+sNVI0+/dQt5GMwm2tjL5pGn38orsN/b90hvpNmAwNMuu7f29vXXu7fIc0Kefqvv/vU/lkSCkUSNIk+/9Y9O+u/xwOR3QJ4B6+f54/y8fA3yDMiR53SCqZQvQZ4BWfKUB4vJ8wt5+uXJ8357HeMnfiFPv0x5jidAGcPmC3n65crT9UmeX8jTL1ueQ5885v6FPP3y5flfR55fyNMvY57/cdHoC3n65cwTX8jTjzxVIE8/8lSBPP3IUwXy9CNPFcjTjzxVIE8/8lSBPP3IUwXy9CNPFcjTjzxVIE8/8lSB59z9yFMF8vQjTxXI0488VSBPP/JUgTz9yFMF8vQjTxXI0488VSBPP/JUgTz9yFMF8vQjTxXI0488VSBPP/JUgTz9yFMF8vQjTxXI0488VSBPP/JUgTz9yFMF8vQjTxXI0488VSBPP/JUgTz9yFMF8vQjTxXI0488VSBPP/JUgWEY/MhTBfL0I08VyNOPPFUgTz/yVIE8/chTBfL0I08VyNOPPFXgvKcfeapAnn7kqQJ5+pGnCuTpR54qkKcfeapAnn7kqUIhiwO/kacK5OlHnirI0sAD8lRBlgYekKcKsjTwgDw16GVp4EHGPPtWfoGbLA08yJdnXxfyK5BnQLY8+yN7Fl/IMyBXIX09/PBGvti97r4w8ChTnt14/20tX+3edVwW+CNPnuf7VRJ2PgV5BuTI83qQH/5PfmP3LjI/8GD9PK+n7wvMN/m9vTvL/MCD1fLsb93l0p5Ovx766uQP9448A9Lk2Q8xdtfL5dw2p1N9qKrCf0tOJd+/d63MDzz4PM/+2h7rg1MNyrIIpOhVsf4cXLifLuDDPPv28OGsrdtrWur2b4dNy7RtcRuX4f82dYZ8kmd/rgzM2M/P/d+GyDvn9sz4HUN21yG8wfk81Nc2Q39Dgcd62L64bctLmxZ8kGf/4whcs5NM7/vYM8zm3TytxPnv31Gm+H3kmc17efaNnW0UeRr2Vp73K+ZGsHE37J08W1O79+Rp2Ot5uhs1Lfn8yJ08s3k5z/FGTUvOMuHvI89sXs3TXJ3/LjLl7yPPbF7M016dEe6KIs9sXszzJH/Njgi3PJNnNq/laXBBRbgpijyzeSnPm8ELxp+fVyLPfF7K08yOZ1EdT217djdmRLhj7zb8U+MdHk3THI+HA4NxruaVPE08EVMcmmsvE5wKz/2u5YU8ewuXMovXdqbfxOZ+JS8sTRMPxKwzblPP9n0dL+RpYeW51sNL9k6w2bQ8TxN7nhGO0xdp5OchreV5mjhsX2vUJnY+17E4z97EOc+1Nu72ru3atDhPI+OsfH4DyBIWr0+YtDhPK+uL5XsrH2DluZLFS9PMqZTm2t1uSU7M9/cn1LsrB0Zr2V6eX4qiLMuqGgcw+cFX7kn+7IEb9sQNfOIeT2dznsPiPLeyeLwHT2yslVqcp3y/ed4zo+Sp1NI8N/PmHe+hPXkqtTTPzbw7wvtsB3kqtbc8/eftv0YThy5L89zKLY7+IW3IU6m95el/6p08ldpbnv6LnuSp1NI8t/LmHf/lJPJUamd5Bu5oIk+llua5kRdDBQb7JE+ldpZn4HZl8lRqaZ4beTFU4HZQ8lRqZ3kGxgMjT6V2lqd8mkfkqdTSPLfx7FfoUSTyVGpfedbyaR6Rp1L7yjP0GDx5KrWvPEPjzJOnUvvKM/SYMXkqta88Q4N9kqdSS/PcxrOzodcgkKdS+8pTPswf5KnUrvIs5cP8QZ5K7SrP4ABh5KnUrvI8yIf5gzyV2lWeoYtG5KkVeTrkqRQbd4c8leLQyCFPTU7Nl6Xv691EnpxYMuGNwVk3cVEz+HbinHkWbhzSyo1DWg+Ox+Np4NYc7ci9LtG5PJDfdu9SHLjvH/7a8LeHf+M+NGl5H5dUfoole80z21WjocChvyE+V974ss/rtXODOPdJhnH+YxzXeRzZubsOvvue0h7jHvO+Fy6RO/cxeMfa79xYvEI+XmS7zTP0wVPnudbrllZ3lA84a9xCjBuIr83DuNr/2jp8ad95sd/t7P7bXS/ntjna3VML3bH00QCKC2bHZvNcOOeq8zpbCXE7n0wO5h06T/FJnkU/v2VZ621g61v09sZm1Tjvrq29tyGEthsf5Xmc/9uhu/TtW3BGp8j16c2dbQqtxT7auC+w6zzXeUm0j7WBwUJXNVPnuc676nKY37EJXklegbH1Z+jEZ+o8l16bs2d+eI6s/zUtvOT9h8A+euo8Q2cM7JvPM+tnNzZyXWA1ljrPpZeO7Zlf/uS5XGA3ffHZ5TeRZybGDo4C++mp88xw3m8lyvM09kqEwLFR6jzlx2zQ/Oop65bD2hs7/DOLPN+lPE9rb4vz73wmzjN4n6l9yvO09ipY/84neb5rfutJni/w73wuurHhfcGHSOwjz7i8c4s83zW/c5f3rIVMhBneu0IS5xl8QtQ+8ozLu3Unz3dpz9Pcbcm+rXviPHPetJMYeUbme7CCPN81f+wh35iJuTx9W/fE9wUG3uS5BdrztPdEh+fWdfJ8F3nG5oklcZ7bfVBTfZ7G7kd2/h4ckefb5COGyfdlYjDPv6c+Ew8ysec8Q8/PrMRgnn/nWOI8t/uYO3km8OfgiDzfJh8xKHOeFke0+TPLyPNt8hGDyPN1j6vPxG+rzzcQQXryEYPI83WP84w83zZ3WSbzva42h6t7WH2S59vIM4GH1Wfix6HJMxubeT4crSTOc7sjgJFnGsWvS0fk+TbyTOLXTW7k+TbyTOPncEuJxzrZc56Zn7Mym+fP/9bk+TbyTOTHjRrk+TbyTOV7cKrEQ/GQZzaG8/zevJPn28gzma+jd/J8G3mmM417nnggM/LMxnSe08n5xEPxkGc2pvP8Gr8j7QN9e84z8wgptvOcHttM+ywceWZj8WGOn+7ppN26k2c21vOUs59JB6Ddcp7yEYPYuH+mGA/fk64+9/wwB3l+ahxDLeUoYOSZzQbyHC++9wkP3skzmw3ked83THhqnjyz2UKexbh5T3fbEnlms4U8ZR4m63PPwzCQZwT3gLq5k3gvK6+O920gGyEfNIg8Y5Cz87FPf2Z+0mYF8kGDMg9cvpE8p/3Da9wDePIkzzimHcRLzDUoeZJnJN97SW0tv/Ux8iTPWO6XN+9ul+Z4rOvDoKqqclAM5BuXI0/yjOew5Bi7H90mXZD7U/k72yVzLog8I8o8Mw2SGRdEnjFt+S0FSch8CyLPqOjzNTLbgsgzrg2/wi0FmWtB5BlZ5stwxshMCyLP2Kq873i2ReZZEHlGV3yPvoQZMsuCyDOBLd+hGZfMsCDyTOHABn4ZmV9B5JlEseWnfyOS2RVEnokct39FMgKZWUHkmcyWH8KIRWZVEHmmU7GFnyNzKog8U6o4x/SczKcg8kyrZhf0GZlLQeSZGsdIT8g8CiLP9FiDBskcCiLPNdQcJPnJ/Akiz3VwFO8lcyeIPFdzYhv/h8yaIPJc0aHlWvxvMmOCyHNd7IX+InMliDxXV59Zh05klgSRZw518/N98Dsm8yOIPHMh0YHMiyDyzKluLvs+nJf5EESe2dXHZtNDzD4jsyCIPJUoDkOm7fl67W63+zhMvRuB6XJpt3zXk3z4IPJUb89jy5OneuSZDXnO2/OLY8hTPfLMhjznkWc25DmPPLMx/z73FZBnNuQ5jzyzIc95e84z82ip5DmPPLMhz3nkmQ15ziPPbMhzHnlmQ57zyDMb8pxHntnEff/5NpFnNuQ5jzyzIc955JkNec7b8+3IlXxfJuQ5jzyzIc955JkNec4jz2zIcx55ZkOe804yr7ZIPmJQ5jwLmQyEkWc25DmPPLMhz3lHmVdbJB8xqJTvy4Q855FnNuQ5jzyzIc95mZ9WTEo+YlDmPGUq8MSW85xbPZGneuSZjUwFnsh8U1lSc3kW8n2ZyFTgCfLMRqYCT2Q+NZ2UfMSgvHn2MhV4IvP+V1LyEYPIU70N53mTjxhEnupl3v9KqZOPGESe6m04z6t8xDD5xjzIcwmZWRt0lk8YJt+Yx+y+BwYyszaolU8YJt+YB3kusd33ax/lE4bJN+ZBnkts9mGjfv6OIPnOPMhzkY2+VbOv5fM9kXXLQZ6LFJt883s/v2nPnOfseS/8UNyVohKHL/VPx99OIc1T8k0+8g8L+akjmZyBTGJVyTSX8hnkE80jTyhGnlCMPKHYTUrJYv6iFvaNPKEYeUKxrKd8yRPPZc3zIhMB+JEnFCNPKEaeUOwspWTRyEQAfkXGM0vX5bcGYKfyPad6Y2R5zMo1SErP64ixQJXltpCOdScWKdrL9drd1qm0729dd7mc2e/Eq4qyOrgbrd091O35fBmyvXbd7Xbr++XxDt/bD3+l67rrZejw3LaNu7e6PlRV+cKN0sCr5Gb8IPk2YIF///4Hr9fa8fCeENUAAAAASUVORK5CYII=",
    preserveAspectRatio: "none",
    id: "img2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 293,
    y: 70,
    width: 670,
    height: 537
  })), /*#__PURE__*/React.createElement("image", {
    width: 32,
    height: 17,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAARCAMAAACLgl7OAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAwUExURQAAABHM3Rm9zhbC0xW9zhfA0RbA0Bi/0BbC0RfC0hfC0RXB0hbB0RXC0RbA0RbB0X1npykAAAAQdFJOUwAPHy4+TV1si5qqucnY6Pf4fs5vAAAACXBIWXMAAA7DAAAOwwHHb6hkAAAAXklEQVQoU9XPSw6AMAgE0NIPoLZw/9tKIjGpoW5c+TYQZjakJ/AZAuyiOrZVKXe9jLgBw3PVw0+z6qkRP82+FKA0IiRPjTQkrNnjuttvIWHr3L/FODXfVv5RKPyG+QTpThOwDDhD9gAAAABJRU5ErkJggg==",
    preserveAspectRatio: "none",
    id: "img4"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 706,
    y: 72,
    width: 32,
    height: 17
  })), /*#__PURE__*/React.createElement("image", {
    width: 82,
    height: 94,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFIAAABeCAMAAACHMLPSAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAzUExURQAAAAA7YgAvXgAzYAA0XgQxXwMyXgM0XwI0XgIzXwIzXwI0XwI0XwMzXwM0XwM0XwI0X1dfcbQAAAARdFJOUwANGyg2Q1FebHmGlKGvvMrXiaCAIQAAAAlwSFlzAAAOwwAADsMBx2+oZAAAATFJREFUWEftmduOgyAQQEEWkHv//2t3gGltY7W7AkkJnKcJDCeBoChDXqCULgB7hWJvBJseQDYMws4Hi7bWOR9CuL3HYiJAsWlP8N5Za1TMYh4bD/mT8k5Mlhgf8y/lbTlXBmeU0mkyGWq00vZ0XqdKy3frjlB5bGWErCnwZgf0nSAx64kk2pRP63UVXGdQqhTUU/40UeoUfLWS96LM26meUoyqlITYFAyodCn4auXaizKfIqMp4YieylI2Zf4ErKfUU4ntBUzluMocTOV1prKFcj7jpUzlVBbTTjk/rAdUDvvz3IFy5Hui2sphLxu7uV5uoOyjRtFA2aDek5Uu1h/LYEm0KevxocJ3hTZK3OuVCPDWADgXQkgpV0AppYFcBbSH5H4TU2GEWlcYLoXgnBHyC+j8cRV0jSvPAAAAAElFTkSuQmCC",
    preserveAspectRatio: "none",
    id: "img6"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 681,
    y: 75,
    width: 82,
    height: 94
  })), /*#__PURE__*/React.createElement("image", {
    width: 75,
    height: 115,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEsAAABzCAMAAADnuQ8YAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAGqUExURQAAAAAAAABVVQBAQAArVQBAYABNZhdGXRQ7YhI3WxFEVQtDWQo7Tgk8VQ02UQs5VQo5Uw47Vw06VQ08VQs8Vg09Uww6Uww8VAw7Uww9VAs8VQs8VQs8VAs7Vgs9VQo8Vg08Vg09Vgw7Vgw6VQw6Vww5Vgw7VQs5VQs7Vgs6VQs7Vgs7VQs6Vgs5VQ07VA07VAw6VQw6VAw7VAw7VQw6VAw6VAw7VQw7VAw6VAw6VQw7VAs7VAs7VQs6VAs8VAs7VQs7VAs8Vgs8VQs7VA07VAw7Vgw6VQw8VAw7Vgw7VQw8Vgw8VQw7Vgw8VQw8Vgw7Vgs7VQs8Vgs7VQs7Vgs8VQs7Vgw7VQw8VQw8Vgw8Vgw7VQw8VAw8VAw7VQw7VAw6VQw6VAw7VQs7VQs6VQs6VQs7VQs6VQs7VQs7VQs6VQs7VQs7VQs6VQs7VQs7VQo7VQo7VQo7VQo7VQo6VQo7Vgo7VQo7VQo7VQs7VQs8VQs7VQs8Vgs7VQs7VQs7VQo7VQo7VAo8VQo7VAo7VQo8VAo7VQo7VQs7VAs8VAs7VQs8VQs7VQs7VQs8VfPzPz4AAACOdFJOUwABAwQGCAoLDQ4PFxoeJi0xODk8RFBTVVZYWl1eX2BiYmVoaWprbG9xcnR1d3h5ent8fX5/gIGCg4SFhoeIiIqLjI2Ojo+QkZKTlZaYmZqbnJ2foKKjpaWmp6ipqqytr7CxsrS1t7i5u7y+v8HBwsPEx8jJysvMztHS1NbX2Nnb3d7g4ePk5ebm6Ovt7vBPdsDxAAAACXBIWXMAAA7DAAAOwwHHb6hkAAACYklEQVRoQ63a6VdMcRzH8TdJlAoRMmTNTsi+ZN8qa3YjGkkSpTKuJWMX+p/dqc8D53CEz/f16D2de34Ppjn3/pbLhPLKyZXp2knMKYz9g0IiD3Kyu1wDQX2iq/7bk4aKiaEy+oPl6vhQc4f00bO6OFZWH0yjVVCrttXBFqVtPmxT2mqhSWlbALuUtkWwV2lLv/sDSttiaFbalsBhpa0ejitty+GU0rYCzihtK6FVaWuANqVtDZxX2tbCRaVtPbQrbRvhitK2Ga4rbY1wU2nbHvboGBvbCR1K2x64q7Ttg5zSdhC6lLZD0K20HYUepe0EPFTaTsMjpa0F+pW2VhhQ2s7CU6XtAgwrbZcgr7S1w3OlLZ39vlDabsBLpe0WvFbasvBGaeuAt0pbJ7xT2u7BB6WtCz4rbd0wqrT1wFelrRe+KW19TFX5+pmm8g1QqvINMl3lG2aGypenROVLmKny5SlT+Z6F/h8jf1+Rv/sp35W2x7H3icj71xelLb2vflTa7sN7pS19DkU+HyOf22HzidvwSmlL5zmR86+weeG1wPnq5dh59KDSls7vw9Yd52LXQ31KW7pO61Xa0vVj2Lr2ZOB6+1jsPkDk/kSn0rY/dj8ncp8pcv8rbF9ua+x+YeQ+Ztj+6obAfd91sfvRkfvkYfv3q2LPFSLPO44obcsCz4eWxp5bRZ6nRZ7z7VDaFsaei0ae14aclBel331J0ITiUzVQNaJPlpHiUDGDDc0aHwrKm8yFXyH708sVFZk7SZL85VsUI+mluVxbS+OmTN28mqrKUg3yi+IbHrNrfqv6jy93wA/Uxamyz2eNbgAAAABJRU5ErkJggg==",
    preserveAspectRatio: "none",
    id: "img8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip9"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 886,
    y: 75,
    width: 75,
    height: 115
  })), /*#__PURE__*/React.createElement("image", {
    width: 49,
    height: 35,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADEAAAAjCAMAAAAKXBK+AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAzUExURQAAAAC7zAnB0wa/0QS+zwe+zwa/0Qe/0Aa+zwbB0QfB0AbB0QbB0QfA0AbA0AfA0QfA0E16NnEAAAARdFJOUwAPHSw7SlhndoSTobC/ztzrVbJD8wAAAAlwSFlzAAAOwwAADsMBx2+oZAAAAQpJREFUOE+tk+2ShSAIhjG/yjTP/V/tgtC0timdmX3++E7yToAAYBUWuFM+c3aJuzjkZsR/OKrcjEgSdyEXQ753fJ/VbkKMMQTnzj6rjkUEsiePDrVXRkSjoEN9wc5R0ZFFj8i/skLQsYkcUXqHAVhFjrg5sGFe5IjDimAsQFfYA9WJYNyLB+mTIIfW3ignQw6tWf09ObTS+xzIoZYuJ0MOtZCO5rBBprHsfM7A90BC0zUaLUGEl6QNSsKJgdS+zmAHdqvQquh9a7NLlPYDQtuvQ+LO+BezL3EXNudj+J+aV27VA2axzvsQ1y2dO1o2d6Uyh1fubzoTeHiH+TxhaY64/a/xubwt4g7AD8mnSIV6FdniAAAAAElFTkSuQmCC",
    preserveAspectRatio: "none",
    id: "img10"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip11"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 496,
    y: 76,
    width: 49,
    height: 35
  })), /*#__PURE__*/React.createElement("image", {
    width: 22,
    height: 32,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAgCAMAAAAhSXi5AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADVUExURQAAAABAQABJbQBAYABAUA45Rw02UQ0zTQs3TgozUgk3Ugk1WAg4WAc3Uwc8UQc7TgY9TwY5VQk5VQk4Ugg6Ugc6VAc4VAc7VQY6VAY5Uwk5UAg3Ugg4Ugg4Ugg4Uwc5VAc4Uwc4VAc5Uwk5Uwg7VAg5VAg4VAg4VAg4VAc4Ugc5Uwc4Ugc5VAc6VAY5VAY5VAY5UwY4UwY5UwY5Uwc5Uwc4Uwc5VAc5VAc5Uwc5Uwc6UwY6UwY5UwY5UwY4UwY4VAc5Uwc5Ugc6Ugc5Ugc5Uwc6Uwc5U3hotU8AAABHdFJOUwAEBwgQEhMUFxkcHSAlJicqLTY7PkZJTk9QWV1gZGVnaW1veHp9f4CDjI6VmJugoaKjpqqztba3vL/Cx8rLzMzU1tnc3+HjypxcygAAAAlwSFlzAAAOwwAADsMBx2+oZAAAANpJREFUKFNd0tdWwmAQReETuyj2jliwx4a9IGKD938kM5ntn8HvJnP2TVZY6J/xmslYLlvLPwamRjBTjXbZClVeaD3QCik3vymlv9zqExx5/4cNz9uspMyr76zE8swNo2L5lDso8pJ/2JAx6Ygz+MpUf+UOelKDM+pIJ5zRvXTNGd1KHc7oQnrmjM6kO85oVzrnrHSbxafvMZLHDfv5Fj+ZaC9blS7ZLp/zqnVC6Tj9Q0arl/Z2aGalS33apLgDry+zbEzmVvN5ZlK/GvQPJxjB9NsW17ARnk76BZTVeMMR8jO7AAAAAElFTkSuQmCC",
    preserveAspectRatio: "none",
    id: "img12"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip13"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 802,
    y: 118,
    width: 22,
    height: 32
  })), /*#__PURE__*/React.createElement("image", {
    width: 22,
    height: 20,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAUCAMAAAC+oj0CAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABsUExURQAAAAC2tgDMzADE2ADM3QDDwwnEzAi5yQXB0AXAzwW90AW/0QTB0gbA0AbBzQbCzga/zQW/zgW/zQe/zga/zgXA0AXBzwXAzwXBzwW/0ATAzwTBzwTB0QTB0AS/zwTAzwXB0AXAzgXAzwXA0PzA+vIAAAAkdFJOUwAHCg0PER4hMTU2OD5RUlNbaGxzh46QoaWorrS1vMDBxM3Q1zu6wW8AAAAJcEhZcwAADsMAAA7DAcdvqGQAAABrSURBVChTbcxLEoIwFETRKCIQASVgoiLf3v8eDalHWVT6zvoMWqWK5jC8rdEnmXsOodU9ziIhYV/f5mK+PwNTcxE9MPAsKONTUsZLU8Y3oYyW87jdxAzLec4o486547xwxpXzjXOtKhNn9A++MyrRrxG/7wAAAABJRU5ErkJggg==",
    preserveAspectRatio: "none",
    id: "img14"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip15"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 824,
    y: 118,
    width: 22,
    height: 20
  })), /*#__PURE__*/React.createElement("image", {
    width: 36,
    height: 20,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAUCAMAAADSpG8HAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADMUExURQAAAABAQABJbQBGXQA7TgBAUA45RwwxVQs1VQoxTgk5VQg6Ugg4WAc7VQY5Uwo5Uwo7Uwk5UAk5VAg4VAc3UAc5UQc7Uwc6UgY6VAY5Ugk4VAk6VAg3UQg4Ugc4Uwc3VAc5Uwk4Ugg7VAg6Uwg5VAg6Ugg6VAg5VAg5Uwc3Uwc5VAc5Uwc5Ugc5UwY6VAY5UwY4UwY5VAY5Uwc4Uwc5Uwc6VAc5UwY6UgY6UwY6UwY5UwY4UwY5Uwc5VAc4Uwc5Uwc5Ugc5Uwc6Ugc5U/AR3xoAAABEdFJOUwAEBwsNEBIVGBobHyAnKDE0NjpARkhKS09RUlhhZGhqa3Z6e32Dg4aHiouOmJmkqa2ur7W5usHHx8vP0dPY2d3g4OLkwVSA6AAAAAlwSFlzAAAOwwAADsMBx2+oZAAAALtJREFUKFOVzNcSgjAUBNBYsYCKvYBiQ8WuqIgFy///kyHs6EDy4nm7uzuXhEjWXEBFGyiv3yJ11ExlhzSiiN5X3SOMeGUwoNQ7wigXA6p9RMaZYEFI54SI18KENJ5IeF4CG/2KRGCATe+GQOBQCDZd3EIam8T7OIVmKX+THOIUWuTZo7SNW8SW2IYQeYqE8xjlsKEMD2mY20QfKI0vKH42ehbtl2w6KJmzVYuhCVOM5ZYunZWpKYj+QMgHvKF2v7/KZjsAAAAASUVORK5CYII=",
    preserveAspectRatio: "none",
    id: "img16"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip17"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 809,
    y: 138,
    width: 36,
    height: 20
  })), /*#__PURE__*/React.createElement("image", {
    width: 76,
    height: 54,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEwAAAA2CAMAAABa8I++AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAzUExURQAAALvMVbvdVbfTU7zRVLnXV7nVVLzWV7nXVrzWVrvWVrvXVrvWVrvXVrzVVbrXVrvWVmIwBEwAAAARdFJOUwAPHi49TFtqeYiXprXE1OPyvuO4KQAAAAlwSFlzAAAOwwAADsMBx2+oZAAAAYVJREFUWEetl1kShCAMRAXZVeD+px3G6nFEQdneFyWhywQSwlQE4WrZrHPOLkbO+NgG0c6fsZpiph5mIXJCE0zWcf2tHwLzNZAFi28YWJQzJ1z8sVW6ytIugjo18agV1GBXwpuW9wqWOQiT2hij2DS/anmHRWno6SC8a3n/dHoLfiZGYmEKBptiFixMIWFTzoOf2eOeJe/nDIsK8vtpYFEDw9or9RELZPL9ORGzJLdAtml5d69sbMVcAzaWmzd8b+QcON7o4Z/tiFxrtM44FMr3slWC3bXoEK1w+33FOrYxJoSNYthP2NKG5M4Qcl5gOADalt1pxEgxOWmMBiCbCmIGMVKMjxSjA8XCORu3AaGLURh2sxehUYnOv1VjkNpegQIjwvbTem6Di3BRyyF75Nx6vYi5aSvfzqnMY4pSxrmQShmzrtv9b53d1mUxWkspOGMzJeXdO7nczWvlMyKGRMem9kly49RL/m/tZo50G6B1dOB98TrYW6TG12oCHZ/wTore+NP0Aa4vpDLZ6nqiAAAAAElFTkSuQmCC",
    preserveAspectRatio: "none",
    id: "img18"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip19"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 536,
    y: 139,
    width: 76,
    height: 54
  })), /*#__PURE__*/React.createElement("image", {
    width: 370,
    height: 327,
    xlinkHref: "data:image/png;base64,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",
    preserveAspectRatio: "none",
    id: "img20"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip21"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 670,
    y: 178,
    width: 370,
    height: 327
  })), /*#__PURE__*/React.createElement("image", {
    width: 8,
    height: 7,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAMAAAACh/xsAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABFUExURQAAAABVVQAzZgBGRgk8TQc6UAY5UwY3UwQ4Ugg4VAc5UQc6UgY6UwY4UAg4VAc4Uwc5Uwc5UgY6VAY6VAc5Uwc6Ugc5VLdDCYsAAAAXdFJOUwADBQseIyguO0BIS1NWW2hrcICFkJurYNGjbAAAAAlwSFlzAAAOwwAADsMBx2+oZAAAADVJREFUGFcliskRwCAQgNCoibe5tv9SdUc+8ADi07MD7C+L23CqRSJ1RyHtCByf+tX7amN4JmYgAz8CQnw6AAAAAElFTkSuQmCC",
    preserveAspectRatio: "none",
    id: "img22"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip23"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 920,
    y: 195,
    width: 8,
    height: 7
  })), /*#__PURE__*/React.createElement("image", {
    width: 21,
    height: 10,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAKCAMAAABsSeXqAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAB+UExURQAAAKqqVbnoXbbIW7vdVa/PULjVVcbVVb/ZWbrYTr3ZVbzaU7jVVb7YVbrVVbjWV7zUUrjVVbvVVLjVVLvVVrzXVbrWU7fVU7rXVbvVVLrWVLvXU7zVVLrXVbzXU7nVVbrVVLnVVLvXVLrWVLnXU7rWU7rWVbrWVLvXVbrWVRHATW0AAAAqdFJOUwADCw4PEBISFBobIiQnMDI1Nk9hYmZvcnJ0dnh5foGHjJGeo6Wptbm+wZEkEIcAAAAJcEhZcwAADsMAAA7DAcdvqGQAAABmSURBVBhXXchXFoIwAETRoaigIpBQrDRp2f8GSczA8XC/Zh7SYfNt28/rLqU4A7naKzzAf/OsygO0S8NrPU4mAknHYDwDG4HbyKRU5bBpcW3blLksP2FhYi94N2JWw5X7T1QduYAFkY4RX5hRxlUAAAAASUVORK5CYII=",
    preserveAspectRatio: "none",
    id: "img24"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip25"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 563,
    y: 199,
    width: 21,
    height: 10
  })), /*#__PURE__*/React.createElement("image", {
    width: 8,
    height: 8,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABCUExURQAAAABAYAA5VQBAVREzRA88Wgk+TwY4UQQ8VAY5UgY6VQU3Ugg4Uwg5Ugg4Ugg6VAc6Uwc5Uwc5UwY6Ugc5Uwc5U4+J7ZYAAAAWdFJOUwAICQwPER0pQFFUXV95f4WNjpOos7lgneAQAAAACXBIWXMAAA7DAAAOwwHHb6hkAAAAOklEQVQYV2NAArwCnKwgmltUVFSYjYGBWQTIEBViYOAA0aIiDAzsYIYgIwODAIjBDVTMxMPPx8XCAABUIwK77xEZ5QAAAABJRU5ErkJggg==",
    preserveAspectRatio: "none",
    id: "img26"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip27"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 920,
    y: 204,
    width: 8,
    height: 8
  })), /*#__PURE__*/React.createElement("image", {
    width: 92,
    height: 57,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFwAAAA5CAMAAACMCLyDAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAzUExURQAAAMzMVbXWWrzTU7zVVLnUVrrVVrvVV7nWVbzWVrvXV7zWV7vVVbvWVrzWVrrWVrvWVn2YTiIAAAARdFJOUwAPHy49TVxse4mZqLjH1ub1OkOmiAAAAAlwSFlzAAAOwwAADsMBx2+oZAAAAc9JREFUWEe1mFuCgyAMReUlICDsf7Wjch2xUF+N56umeokJCWB3CBNKSYkLUlgfYloYLUxk9FDO9LCSwBxUVxrOMyE4ft6Cj9DccPgLSBOy+d47CWV8rZ2SLtwUxYuFy/IcDrVxRrLpJmZ3+UhDfvaEz6daRGc+85HCNCST2jrvnFHz+DXyXPoLo1mn7Yxr5Fk/1q4wkPxH0Gmn5CG64mGnYe+7gJWKXUvSMFIxQndhgJGMsraqyfsrZb8gF09FMVmY6CjiYmCio2g5CiY6iqBzmOj4ryN5oR/eJCKhkrb0M9nxK138Ptnxai2mQb+onXcL9PN7Zl74JsffiDe0yTttBs38nYijflrbn99B5b8S8hTeFMcad7R7ew48p18jZhDzHpe0YLYwXNIisvgrcdmOIYI8pyj+jKatJF9qTyi6pWjUH9ozygw+OPfTKDFY0ZAueHQGiEZJwY+FF9j9DPt17p3D3LnzcbsluuvSC/ZkAkXV8d4MbrD6JMotuJ+OfVN+Q3OU8Ohc3qKuYXvf2S9Up7wpJFRU2gOZ29UKfmPSncN3jnvSjzo7xz3x565tzxQtZUBm1j4T3fKhhRK2HHyjNw+K8BgmtHdWy8fB6Lo/QyTRCmhRJmMAAAAASUVORK5CYII=",
    preserveAspectRatio: "none",
    id: "img28"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip29"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 803,
    y: 214,
    width: 92,
    height: 57
  })), /*#__PURE__*/React.createElement("image", {
    width: 70,
    height: 58,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAAA6CAMAAAA6EN8MAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAzUExURQAAABC/zxDFzha+zhS+zhTB0RPBzhW+zhTA0BTD0RTD0BXB0BTC0RTB0RTBzxXB0BTB0HA/ry8AAAARdFJOUwAQHy8/Tl5ufYycrLvL2+r6Ty0O5AAAAAlwSFlzAAAOwwAADsMBx2+oZAAAAYVJREFUWEetl1kWgyAMRRktOHb/q63gs6WCSoL3S9C8E0IIUVwjlTbGaIUhHWncOC3vnXnoncGrarRLFBIGgpR0E6xKLL5KSfmiHymzv4uVvBeJDBoGJWpFAoOEUYa5iknGUo4RxZUNB8sUTXJlY4DtD0t1JTLCesdjnsoE+4jsMUsn1Rkwx+G3LosZHi+oCMYepSB/2pxZ83CTGTFkE9NQY8AnuuMwaCBEuXlNawFaUw+PTajmfYp04oWnJpzgH6eEvuk8fXlM5pFFeXbB+sM+kcRP5U0ogaxa/k844g/EOFzp7YViu64aa+h72dqCVnd8VGmNzry3FrJlWUljoTDFIW0rDObo9FDY4OpMh55Ls5L5qLLGhxHnqdSRkktGUUWIjrYwd9qLUhIxb/wSXjO+uuXb15SxlS7dyKxYX+FTqSvOUJ2/yQDUhwps5/rx1LHF4rNapFKq0MUvrH/H/Cq63PNTdLaHHd4QscfWjKkjzMGjvRDTsS71Ka8VBNSaCwHfBRUhPqlOswrrSCc4AAAAAElFTkSuQmCC",
    preserveAspectRatio: "none",
    id: "img30"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip31"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 292,
    y: 214,
    width: 70,
    height: 58
  })), /*#__PURE__*/React.createElement("image", {
    width: 21,
    height: 11,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAALCAMAAACnFTZPAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAB7UExURQAAAID/gKqqVaqqVarVVcbGVbzXUbbOVbXVSrPQVbPMVbfXULbVT7jUV7nWVrnYUbzWU7nWVbvVVLvYU7zWVbrZUrrZVbvYVLzWVLrWU7vXVLvVVLvWVLnXU7rXVbvXU7rWVLrWVLrXVbnVVLnVVLnWVLrWVbnVVbrXVPAygYUAAAApdFJOUwACAwYGCRMVGBseICovPkJERU9WV11dYWprbYuPkZOlra6xtre5uru9s1svUAAAAAlwSFlzAAAOwwAADsMBx2+oZAAAAGlJREFUGFdVzNsSQ0AURNEmkZC4BhHXQZDz/1+oxjQV6+n0rqmBFxx8173C8EY5mZRqH0DSc+/Gl36dcdGcbn9YJbeRbxGwOwbtwwg4NZNIwaTd+EkTMRiX91fkVz05D/EyhDz/+XceAFb41hEZnb697QAAAABJRU5ErkJggg==",
    preserveAspectRatio: "none",
    id: "img32"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip33"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 563,
    y: 215,
    width: 21,
    height: 11
  })), /*#__PURE__*/React.createElement("image", {
    width: 8,
    height: 7,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAMAAAACh/xsAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAwUExURQAAAABVVQBVVQBAVQ45VQg6Ugs3Uwo5Uwg4Uwc3VAg5Uwc6Uwc5Uwg5Uwc4Ugc5U/nxG/IAAAAQdFJOUwADBgwSHy4xZXOHjZOlvsRBnmMHAAAACXBIWXMAAA7DAAAOwwHHb6hkAAAALElEQVQYV2NgYGEHAWYGBk5+EGBnYOKDMtjANJDBDmMw8kIZDMwc3Dw8XKwARlACVAfVzn8AAAAASUVORK5CYII=",
    preserveAspectRatio: "none",
    id: "img34"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip35"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 920,
    y: 215,
    width: 8,
    height: 7
  })), /*#__PURE__*/React.createElement("image", {
    width: 8,
    height: 7,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAMAAAACh/xsAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABOUExURQAAAAAkSQA5VQBAVQ88Wg45VQs3Tgc8UQU5UAQ5VAg5VAc3UAc6VQY7UgU3Ugc4Uwc6VAY6Ugc5Ugc6Uwc5UwY6VAY6UwY4Uwc4VAc5U/cZN60AAAAadFJOUwAHCQwREhcmNjpDRktXXWhzdo+QmZ2fo625hjqNvQAAAAlwSFlzAAAOwwAADsMBx2+oZAAAADlJREFUGFcdikkCgCAUhdBssMm0rN79L9o3NrAAxm2ZO4ws6V2hrxZ6PLFZGph+Fwdni91mf9xXCnxldANVXouVhwAAAABJRU5ErkJggg==",
    preserveAspectRatio: "none",
    id: "img36"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip37"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 920,
    y: 225,
    width: 8,
    height: 7
  })), /*#__PURE__*/React.createElement("image", {
    width: 8,
    height: 6,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAMAAADJ2y/JAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAA2UExURQAAAABVVRQ7YhNCVRc8WhFAVw9CXBNBWBJCVxM+WhNAWRM/WRNBWhRBWRNAWRNAWRNAWRNAWWuysdoAAAASdFJOUwADDRsiLDJDRl54iZaaoMzT1uy+EakAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAAvSURBVBhXHcZJAgAQDAPAoHZa+f9nldMMgKa7B1eM5PSoS0bIlxnpPC0CZSzVigsyUwH6goIcGgAAAABJRU5ErkJggg==",
    preserveAspectRatio: "none",
    id: "img38"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip39"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 920,
    y: 235,
    width: 8,
    height: 6
  })), /*#__PURE__*/React.createElement("image", {
    width: 38,
    height: 24,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAYCAMAAAChk39BAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADkUExURQAAAP///9/f3+jo6N3u7uTk8ubm5tzo6Onp6ev19evr6+bm7t/n5+Hp6eTr6+zs8+3t7ejo7uPo6OXq6uLn7Ojt8ebu7ubq6urq7uPr6+Xp7Obp7ePq6ufu7ufr7ujr7uju7ubr7ubr7ufs7+Tp6+br6+br7ebq7Obs7ujs7uXr7ebr6+js7ebs7efs7ufr7OTp6+fs7+fs7ubr7OXq6+fr7ubs7ebs7ubr7ubq7Obr7ubr7ebr7uXs7Ofr7Ofr7ebr7ubs7ebr7ebs7eXr7Obr7efr7ubs7efs7ebq7efr7ebr7RafNtAAAABMdFJOUwAECAsPExQWFxkaHiAiJikrLC0xNTg8PT0/REdISktNTVpbXmZxcXh7e4GCg5GSlpidoaWoqKywtLi/wsPHyMrM0tbW2Nnd4Ojs7vDKPmJYAAAACXBIWXMAAA7DAAAOwwHHb6hkAAAA6ElEQVQ4T33Qa1cBYRSG4W2aUkSkJp1GNVMqQpRKyqEDmf//f/DOvVaMPa5v77Pvtcwiqs10xnHcy7NCiiEqU/4YBouGneda2eEasvwOx4gqwdzu9TvriiuSGe+HTbFPI7kHFs1oi+pg+bsjulSlTwbdTVidxn678Z03lb32F4Pg0VRyzzPOhan2/njGeDWVtHjGeNswVfaLt+6Jv9bjretth5W0GVQvNpX0WRSTSpJIbCbF2KOZOWJb1SiSzDmMUQOXIKRnXc/iDiUbNw85/jvmht/27fkOp0VWwfXv6kbVP8kmmJeITAHkIrMs1jMNDwAAAABJRU5ErkJggg==",
    preserveAspectRatio: "none",
    id: "img40"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip41"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 389,
    y: 264,
    width: 38,
    height: 24
  })), /*#__PURE__*/React.createElement("image", {
    width: 25,
    height: 66,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAABCCAMAAACVfo1lAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAF0UExURQAAAP///////9/f3////93u7uPx8eTk5OTk8tnm5ufn5+jo897p6ePj7O329ubu7ubm7+Hp6ePq6uHn7efn7eLo7uPo6N7k6eXq7+To6ODp6eLm6ubq7+Pn6+Pn6+Tn6+js8OXp7Obp7ePq7uHo6+Lm6eLp7OPm6eTn6uft8OXq7ebr7uPp6+br6+bp7OHn6uPo6uPo6+Po6+Tp7ubr7uXp7OXq7uPq7Obq7Obo7eTp6+Ln6+Lp6+To7OTq7OXp7eXr7ebq7OTm6uXo6uPp7OTp6+Tp7eTp6+Tq7eXq7uXq7uTr7OPm6uTq7eXq7eXq7eTq7uXp7eTq7eTp7OTp6uTq7OTp6uXo6uXo7OTq7OPp6+Pp7OTp7OXp7eTp7OTq7OTp6+Xp6+Xp7eTp7OTp7ePo7OPq7OTp7OTp7OTp7eTp7eXp7OXq7eXq7OXq7OPp6+Tp7ePo7OTp7OPp7OXp7OTp6+Tp6+Xq6+Xp7eXp7eTp7OTp7HlNqeEAAAB8dFJOUwABBAgJDxITExQVFhcbHB4fIiUqKiwtLzE4OT0+P0BBQ0RGSUxQUFJUVFdaW1tcX2NkZWZnamxubnBydHR5eoCAhIaHiYyMjZCSk5ecnp6foaapq6ysra6usre4u7u9vsPDxMbHyMvNzs/Q1dbX2Nvg4uTm5+jp6ezt7vKCKIUCAAAACXBIWXMAAA7DAAAOwwHHb6hkAAABrUlEQVQ4T3WUZ1sUMRhFg4BSLBRRFAtNAQFBEEVgLQhIs4AFlKKgFAXESsuf903mZCYJ6/my997zZHeendlV+TjDa8TpvskdYkjjgtYHZyk+bZ+1cJXmcWfLCN1MTSkY+GXFcfMk2bWuY3B0sWs9lcv5x9q+s1tmWIVrK2wJmTk/xwSpOTHP4phCqHsMKe5M7ReGFGfG6BmYlr/0jMSUv6N6JKaP5mOvreQjzceeaacEWPOKEmDMlT1KgDHD5BAxlRvkEDHNxAi56gfECDkzTowQs0yMkHdbI0bImW/ECDE7xIj/G/mcdWKEnFkiRoh5Q4wQ84wYIaaXGCFX0ECMmFaq+IgcYp6Q1+SQETGD5JBHYqrJITkxBbOUgPtivN+nR48xZfluXqcxqpvm02HNybdUjyZrVOsBPeN6YtQLeob7G7mwyJByEaNu/WZxVCGUesziOMcu38TQH7aEU+yGu7uMliJWy+2vrMI+G9z8xK71DyZH/QeE3mZJueRu8CZDRs3zxKzSPSomrFmi+pQ+NeY9LaDw4aHWs5SI/p/6JTHmxpF5EPNyeZRwnEL1D6Kj9zvXMRuBAAAAAElFTkSuQmCC",
    preserveAspectRatio: "none",
    id: "img42"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip43"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 486,
    y: 264,
    width: 25,
    height: 66
  })), /*#__PURE__*/React.createElement("image", {
    width: 39,
    height: 33,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACcAAAAhCAMAAABtJEIaAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAzUExURQAAAAA3SQAuWwAvUwAtVQArVgAtVwAuWAAtWAIuVgIvWQIuVwItWAEuWAEtWAEuWAEuWMHuG2IAAAARdFJOUwAOHCs5R1VjcX+Nm6m3xtTiWFLiFwAAAAlwSFlzAAAOwwAADsMBx2+oZAAAAOpJREFUOE+NlFkShCAMBUFEXGDi/U87CXlWgcVifyXasiSgedg2BEPsed8fRPe7mVVC63zYGb/kNxUriXaTc3vSUKDjpUJrcJWm62rMDokXlNfWJUIzFx70SKoFpH10xBXZgFPF8fqEXFhjPDdjCKlnZt5TnXJm8ghKfllzyATaqq+ATrwhEw63RIQlVrx5CdWbbgPerHOMaF/Gy96BpI+ehVbFarTDFlkfn71WZSsIx3828aXarDKEc8UrHF2l4i4N79yZmwGW7l5iqTHtrlB4ac9PpoKiw8uK10VJe9MSbIjEpHQdazGhMX8zEDh2lnuKqgAAAABJRU5ErkJggg==",
    preserveAspectRatio: "none",
    id: "img44"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip45"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 413,
    y: 285,
    width: 39,
    height: 33
  })), /*#__PURE__*/React.createElement("image", {
    width: 123,
    height: 73,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHsAAABJCAMAAAAqq6nrAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAzUExURQAAABC/zxC/zwu/zwzC0g3Czw2/zw6/zwy/zw3A0A3A0A3A0A3A0A7B0Q3B0Q3B0A3A0JwrlRgAAAARdFJOUwAQIDA/T19vf46err7N3e393GosAAAAAAlwSFlzAAAOwwAADsMBx2+oZAAAAiFJREFUaEPFmNuWgyAMRY1gRUXp/3/tAKad1qokSmA/OR3gLCDk1tAB1ZnRzotzyzKNRuPP4oA21j03TAbw33KAHn50kanFMTLAoXBEUl0vKHLIgCOz059uemVWODgrMOLyCTocnxGYcO0kD5yRDbp0dnGOdGZxnvTzmdPPDbgmFZfP2jtcks6CM28DhHe9ZcK5d+GeeOR95aCUuuxrNa7Gw4Wp0I3z+udyLdAxbfyFadQm8ozs7SucycWNv2bCDTUG52WBF2ogGTdZsF4+/22f4xgml/XIA4yXn/fIA2RrB5yQkRGXTnL1hZ0QvQ6FB07ICS6dpMfxOaFa+qU4koBqbMTklAV13wLaxLwC0pUIH0epWxPV1y0mc3brraByxB6l0pJ7fjPvqj8KKAd+/Su3FLjBsonnSsC4D/lOJnSh80Y+xUtd9Zv/TEaVlv7PZDKnhjSwVSERt5Ks2cS1+uc20ceUe9hfhNDW4ndxfGCRyJBI9NWOPD6zGg8sYpsGv8rj6pma1xYogKhU1a53314bm0IVkKlCSMwyVSeJwUdv/CxOiOCVHFtMm6qkDqEH6al06GuqWsXSsdUp0NtJ4l4laQX34hOHlfIb/2gu526gppg/2y9lnduXdNkk3W6bTsWKYNdvpT1l/Jvdb+Qr+XR53tv0ihZ1cc7qQ+VA289OoBp3zlmzf9o7AEDrUR4d6JDHMTgiDg/zlJ/vlznYa9P8AfEZl0wl1d3gAAAAAElFTkSuQmCC",
    preserveAspectRatio: "none",
    id: "img46"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip47"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 848,
    y: 339,
    width: 123,
    height: 73
  })), /*#__PURE__*/React.createElement("image", {
    width: 12,
    height: 19,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAATCAMAAACTKxybAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACHUExURQAAAAD//wDV1QDExADI2wC73QDD0gy2zgzF0Qu80wrC1gm9xgm71Qi/xwfBzwfD0AW+zQW90ATAzgjAzQfBzgW/zwW/zwXBzQXBzwXC0AS/zgTC0QTB0AS/zgTBzwTAzgXBzwXBzwW+zwXB0AW/0AXAzgXBzgS/zwbA0AbB0AW/zwXBzwXAz9XkFVYAAAAtdFJOUwACBg0ODxEVFhcZGx4gJSYzNjk9Tl9gZmtxc3V3eHt+j5CWl5ynqLS3uL/AykVz1vMAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAB0SURBVBhXVc7HFoJAEETRQjGBAUQJEhUQQ/3/99kjfWSs1X2bnoG3xrTgEahkBz7PM7UEWWytYBNawf5kBV/JfAqy3lvBW4SdUlbDV5HVBq6S5Qpw3qPzpbk9fH1ZGOMuHGLziqwjr9FIoGX2+zXSo+JvwAcHpxI7p6hE2AAAAABJRU5ErkJggg==",
    preserveAspectRatio: "none",
    id: "img48"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip49"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 782,
    y: 364,
    width: 12,
    height: 19
  })), /*#__PURE__*/React.createElement("image", {
    width: 13,
    height: 18,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAASCAMAAAC3taQAAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAB1UExURQAAAEC/vyS2ti650STI2yu4xiu41THC2ynC1iO5yiO/1STE0CbC0CTE0SbA0SXC0yfB0yTD0yTC0SbD1CbD0ifF0ybD0ybE0ibC0ibD0yXD0SfD0yfC0ybD0ibE0ifC0ifC0ibE0iXC0ibD0ibD0ybE0ybD0pC65W0AAAAndFJOUwAEBwsOEhIVGR0kKzY4PUtWYmlrcnuAjqCnq7K5u8HFxsvN1tzg5OLd9A8AAAAJcEhZcwAADsMAAA7DAcdvqGQAAABpSURBVBhXXc3XDoMwEETRIRBqEnpNgRTm/z8RG1ZiyX2ao5Vs4OJANTxiWbYXp8KVjTNNfSiKrPi9afGTa/FXnZTI1ny1i93hdt01p/qV2gLBhre3CrPFPdmAJzmWvgAD+0imqclk/AUstvUPDB0fdtkAAAAASUVORK5CYII=",
    preserveAspectRatio: "none",
    id: "img50"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip51"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 801,
    y: 365,
    width: 13,
    height: 18
  })), /*#__PURE__*/React.createElement("image", {
    width: 553,
    height: 333,
    xlinkHref: "data:image/png;base64,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",
    preserveAspectRatio: "none",
    id: "img52"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip53"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 425,
    y: 382,
    width: 553,
    height: 333
  })), /*#__PURE__*/React.createElement("image", {
    width: 34,
    height: 41,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAApCAMAAABnXgszAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAERUExURQAAAL+/QNXVVbbbbarGVbPmZrnRXb/fUMPhS7zXUa3MUrHOTr3WUrnRVbnZU77bWbnWV7jUV7rPVbnXULnVU7nTVLvVVbnVVbjWU7rTVLrXVLrWVrnUVrvYVLnZU7nVUrnWUrnUUbzYVLzYU7nUU7fTUrnXVbvWVbrWVrnWU7rXVLnWU7vXU7nVUrnVVLvXVLvWVLrXVrzXVrvWVbrXVLvWVLrYVLrYU7rWVLrVU7rWU7vVVLrXVLrXVLrVVbnVVbnVVbrXU7jVU7rXVLrXVLvXVbrWVbrVVbvWVbrWVbrWVLrWVLrWU7nWU7nWVLrXVLvVVLrWVLrVU7rWVbrVVLnVU7nVVLrXVbrWVLrXVLrXVEYA1BEAAABbdFJOUwAEBgcJCgsQERMZGh8hKCssLzAzNzo8QkRGRkpNT1BUV1hbXF9jZmlrcXN1eHl/f4OGhoqRlZucoKKipKeqq66vsri5vb7BxMbHyMzT1Nja3d7f3+Hi4+Xm5ulvAcVTAAAACXBIWXMAAA7DAAAOwwHHb6hkAAABOElEQVQ4T33U11ICQRSE4YOrmBUQMQsYMGDEHEFFDJhQEfX9H8Td4aeWCfjdbE133+3UiJPH1y0SW96vVDk4eOlS/dfXadI1vXsf9J0nyTK9zzmJF96pA65J9pWyyTFZ/aSDPVmpUbVYkyWKkDkZe6AImZMD8jbGZOaNvM0LHc6JNXRNA8+kmn5aZYpQN0SrrBPqRmmVEqFunFa5JdRN0ioVQt0crXJHqFukVaqEug1axT2pD1IHTgkNe9SBbTJTjt63QGT62exhITEi2ywL8Roklh0WIscktjwLiV+TWG56mUjmg8gyz0Jki8RykWIh3hWR5SnBRKIdN48s/tnUwrsVvSQzNdretJx6nmxJ+sDECaHusJs+0Jc5+iJv+S7mUxFqjBTK4S+rnq0Nk+sisXTWl05Em2eRP6d4GBalykzuAAAAAElFTkSuQmCC",
    preserveAspectRatio: "none",
    id: "img54"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip55"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 313,
    y: 390,
    width: 34,
    height: 41
  })), /*#__PURE__*/React.createElement("image", {
    width: 24,
    height: 21,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAVCAMAAABrN94UAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAzUExURQAAAAAuRgAuXQAtUwAtVQAuVwAuWAAuWAAuWQMuVwIuVwIuWAIuWAIuWQIuWAIuVwEuV4w7wr8AAAARdFJOUwALFiItOENOWWRveoWQnKeyU4sejAAAAAlwSFlzAAAOwwAADsMBx2+oZAAAAJVJREFUKFN1kVsOwyAMBE0JuEB53P+0tRenTax2vnZ3FMVRiB70h7VGqxytXVibWQ4bTkwIPdu00WlAOKUDU6owq9oqaGUNDNMDVuEjKOCpcd7/FfbQsHIVdGhrO9/ENgnxLihJnUhOUJOOz/EiSMf7vSA9Wk92IsSnDSoa55yZS3n1qR0XI3j0LosOeYklh/w1/gXHN4WYDp/wyjHLAAAAAElFTkSuQmCC",
    preserveAspectRatio: "none",
    id: "img56"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip57"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 335,
    y: 390,
    width: 24,
    height: 21
  })), /*#__PURE__*/React.createElement("image", {
    width: 22,
    height: 17,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAARCAMAAADub6yxAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACfUExURQAAAABVVQBAgAAzTQAnYgAgYAAmWQAsWQAxWAAuVQAyVQAuVQAsWQAsWAAvWgAtVgArVgArVQAuWAAtWgAwWAAuWAAtVwAuWAAwWgAtWAAvWAAtWAAtWQAuVwAuVwIwWAItVwIvWQItWAIvWAIvWQIuVwIuWAItWAIvWQIuWAIuWAItVwEuVwEvWQEvWAEuWAEuWQEuWAEvWAEuVwEuWGeYqdUAAAA1dFJOUwADBAoNEBQXGiEkJy40Nj5BQkNES05PVFVaXWBhZGlrcnh9gomMkZ2kpaaqs7i6vb7Hys/R5eUxbgAAAAlwSFlzAAAOwwAADsMBx2+oZAAAAItJREFUKFNtzNcSwjAMRNGFUAOh92Ja6B30/9+GbRbbMJwn6Y5GKFaSpNMbKLVYeVVM5I8asOUYKgANjoFrFoj2XLwdtOadm5OajCU3p2Vz/ef8YCvQ/n7fZ0bMYF0yrMCGSbt12bQhm8hzxGREKavMWd5KrGv/2MiNTzqep3nuTvyQY5lzaKY+D4AXiYEsjzVTDp0AAAAASUVORK5CYII=",
    preserveAspectRatio: "none",
    id: "img58"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip59"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 337,
    y: 411,
    width: 22,
    height: 17
  })), /*#__PURE__*/React.createElement("image", {
    width: 42,
    height: 37,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAlCAMAAAADS4u8AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAkUExURQAAAAC4xgu/ygbB0gW9ywS/zQTB0ATB0QTA0AXAzwXAzwXAzxGDx88AAAAMdFJOUwASGC02SHx/go6mvgWX19oAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAA5SURBVDhPY2BhZWVmIA5wcHNzQJmEwKjSUaWjSkeVjiolQSknNzc7EzGAEWQqcYCTFKVsXMQBLjYAWkAKcWQNwVcAAAAASUVORK5CYII=",
    preserveAspectRatio: "none",
    id: "img60"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip61"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 675,
    y: 443,
    width: 42,
    height: 37
  })), /*#__PURE__*/React.createElement("image", {
    width: 32,
    height: 20,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAUCAMAAADbT899AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAzUExURQAAALPMTbPZTbvVVbnSU7jWUrvVUbrXVLnWU7rXU7nYUrvXVLrWVLrVU7vXVLnWVLrVU5lqGgUAAAARdFJOUwAKFB4oMjxGUFljbXeBi5WfXdxwMAAAAAlwSFlzAAAOwwAADsMBx2+oZAAAAKNJREFUKFN9kNsWhCAIRUXQtBrl/7920E5Nl7H9orBdCLhXfCDc/iG5qE4InshHG6MHvHStmpC4IRVeIzI3eKtvBGTuEHwdToE/FoQNylqWnKKI9zRtXgXSoL3vMxnSoBW5g5pi/HXAtjSj5H406mVA3nqa2bGE1B+fqh97yXvFYHjcG/BpNHPovg627lzsvjDCJ32+OvaOZtX1xRsk55YvOPcFUDALAL3j58EAAAAASUVORK5CYII=",
    preserveAspectRatio: "none",
    id: "img62"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip63"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 681,
    y: 446,
    width: 32,
    height: 20
  })), /*#__PURE__*/React.createElement("image", {
    width: 8,
    height: 20,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAUCAMAAACHxYxZAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABXUExURQAAAAD//wCqxgDDwwjD0gfE0Qa/zAbBzQbB0gXCzAXEzQTAzgTCzwTF0gTC0QS/zgTAzwPCzwO9zQPC0gO/zQXBzgW/zwXBzwXA0AbBzwXAzwXAzwbAzzXcnGsAAAAddFJOUwACCREiJygpLTI4OTs+Q0RFS01PW2Nka3GAm561ALxHhQAAAAlwSFlzAAAOwwAADsMBx2+oZAAAAFJJREFUGFc1ylcOgDAMA9CwNwXKKK3vf04SVPvHT5ZFpA6h1JI+AZPhAvBoH9qICm9AI3L+cFxu4iVikT+o8oKOGIiZWHl2XHZiIxZiFJ8sqf0AXggNsvPKzmsAAAAASUVORK5CYII=",
    preserveAspectRatio: "none",
    id: "img64"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip65"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 705,
    y: 456,
    width: 8,
    height: 20
  })), /*#__PURE__*/React.createElement("image", {
    width: 7,
    height: 18,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAASCAMAAACglzTJAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAqUExURQAAAAD//wi+zgW+zgW/zwW/zQbB0AbAzwXA0AXAzwTAzwTAzwXAzgXAz409Ed4AAAAOdFJOUwADQ15ka3eFkqa6vtLVV+dWSAAAAAlwSFlzAAAOwwAADsMBx2+oZAAAAClJREFUGFdjAAEWdiYQxcHDy8rAwMjJywuiuYEUiAZRvGy0p7mAgIsZACv1BH5cBAiZAAAAAElFTkSuQmCC",
    preserveAspectRatio: "none",
    id: "img66"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip67"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 690,
    y: 458,
    width: 7,
    height: 18
  })), /*#__PURE__*/React.createElement("image", {
    width: 8,
    height: 17,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAARCAMAAADXCB3qAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAhUExURQAAAAXCzAW/zQS+ywS+zgO9zgPB0QbCzwXBzgW/zgTAzoiT4n0AAAALdFJOUwAyODtDSU6Fk5yy125cZQAAAAlwSFlzAAAOwwAADsMBx2+oZAAAACVJREFUGFdjYGRnZ2dlAAIWLiDgYGdkYAIxuLjYBobBzAkCnMwAPUMETF3AnPwAAAAASUVORK5CYII=",
    preserveAspectRatio: "none",
    id: "img68"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip69"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 697,
    y: 459,
    width: 8,
    height: 17
  })), /*#__PURE__*/React.createElement("image", {
    width: 7,
    height: 12,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAMCAMAAACZS1ciAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABIUExURQAAAACqqgnEzAfF0wa8zgXD0gW+zAXA0AW/0ATBzgTAzwTAzwTC0AXBzwW+zgXAzwXAzgTA0ATAzwW/0AXA0AXBzwXAzwXAzppRLw8AAAAYdFJOUwADHiMqMzdhZ3OGiYmQkpqds7a8vcTKzfoDTm4AAAAJcEhZcwAADsMAAA7DAcdvqGQAAAA9SURBVBhXLcVbEoAgDATBRURQ8RFU9v43JaYyH9Owoj0czSzsk5I6uag7yQzMCiuw/l7A6b7u5z7uLSKyDZ0kBDXzCq/AAAAAAElFTkSuQmCC",
    preserveAspectRatio: "none",
    id: "img70"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip71"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 682,
    y: 464,
    width: 7,
    height: 12
  })), /*#__PURE__*/React.createElement("image", {
    width: 13,
    height: 19,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAATCAMAAAB86XelAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACNUExURQAAAID/gKqqVdX/VcbjVbHETsPhWr/ZTbjWUr/cVbnZU7nWUb7UV7jWV7naU7rWU7rVVbvVVLrZVbrYVLnWVLzYVrvVUrrYVbvWU7zWVLrYVLnVVLnVU7vYVLnXVLvXVbnVU7rWU7vXU7nWU7rWVLjVVLvWVLrVU7rVVbrWVLrWVLnXVLnWVLvXU7rWVH4hQcoAAAAvdFJOUwACAwYJDREUGSQoLC8yN0pOT1FVWFxtb3F2fYCEj5KTmZylqK2xtLW4ucDFxsfJO41VxgAAAAlwSFlzAAAOwwAADsMBx2+oZAAAAHpJREFUKFNdztcSgjAUhOG1oGAX7A0rguC+/+N5QvYi41793ySTCaIxgsXNrq+0ReR1rm7Fej+SYhNZTbzcme3pb0t8LULxnYZimQE9tS0Huh81t0O7Wvgu1x33zKPFXf+5OVxmHjgbjomAE7+bgRo4NEuV22qq+BvwAz4AEnroUmTEAAAAAElFTkSuQmCC",
    preserveAspectRatio: "none",
    id: "img72"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip73"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 456,
    y: 543,
    width: 13,
    height: 19
  })), /*#__PURE__*/React.createElement("image", {
    width: 13,
    height: 19,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAATCAMAAAB86XelAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAB7UExURQAAAP//AKqqVdXVVb/VVbTSS8LgUrzaWrnWV7vVU7rTU7nWUrnXU7jVVLzWU7jUU7vVVrnWVbvVUrzWVrzYU7nVU7nVVLvYU7rVVbnXVLrWVLzWVLjWVLrWVLnWVLrWVLnVU7nWVbnWVbzXVbvWVLrWVLnWVLrWVLrWVKxIFzcAAAApdFJOUwABAwYMERkiLDE0Pk1PUFNWV1prbnh5e36AiIiUm52jpaivsrO2ubrFVlXIIgAAAAlwSFlzAAAOwwAADsMBx2+oZAAAAHFJREFUKFNdztkOgkAQRNECEVAUZVVcWASx/v8LmRmbpEM93ZPOJAMcoMcqkLIj3ydP2oqsY4ET50SLn7MWp4sWv1ct/nItdjtglGYTmdsgqEL7rv2j3Fvg5VC4Bp6m+1SAO/k4SgM3lr6kWbZ+eDNgAfLOEGGqJvNiAAAAAElFTkSuQmCC",
    preserveAspectRatio: "none",
    id: "img74"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip75"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 475,
    y: 543,
    width: 13,
    height: 19
  })), /*#__PURE__*/React.createElement("image", {
    width: 13,
    height: 19,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAATCAMAAAB86XelAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACEUExURQAAAL+/gNXVVb/VVbvdVb3ZVbLRVb3bULrWU7nSU7jUV7rVVbfTVLnVVLvVVLvTUbnVUrvYVrnUVLfUVrzWVbrUU7rVVLvWVbrVVLrXVbnVVLrWVLvWVbnXVbvXVbvWU7nWU7nVU7nWVLvWVLrWVLrWVLrVVLvXVLnVVLrVVbrXVLrWVXvWbB0AAAAsdFJOUwAEBgwPGyEjJSgvMEBJT1JUVlhZY2tzdXp+gIKEh4eKlpmaoaOtsbO2uLrB7XzEjAAAAAlwSFlzAAAOwwAADsMBx2+oZAAAAHFJREFUKFNdy0kSgkAQRNEURQQRRAbnAUGlyfvfz+6mFhXk6r+oKGALPR6XUm7kO1tIO5GnROBFk2rxm2vxt9fiUGjRlFrsA+AjzXtsb53gtnF/rwnXyAFPj8vaA2fbYx1OQEO2O2mg4mMlaXfIJGYD/rVjEdtq6YSRAAAAAElFTkSuQmCC",
    preserveAspectRatio: "none",
    id: "img76"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip77"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 494,
    y: 543,
    width: 13,
    height: 19
  })), /*#__PURE__*/React.createElement("image", {
    width: 259,
    height: 14,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQMAAAAOCAMAAAAc5omTAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABsUExURQAAAAAgYAAuXQAzWQAuWwAwWAAuVQAuVwAvWQAwWAAtVgAwVgAuVwAwWAAuVwAvWAAuWAAvWAAuWAIvWAIwWQIwWAIvWQIvWQEvWAEwWQEvWQEvWAEvWAEvWQEvWQEvWAEvWAEwWAEvWQEvWMEdFiwAAAAkdFJOUwAICxQcICEsPEBEUFhgZGh0fH+OkJaeqq66vsTI0tre4vb6/gPSey0AAAAJcEhZcwAADsMAAA7DAcdvqGQAAACUSURBVEhL7ddLD4IwEATgEQHBBygiKj4A9///Rw2ZvSxng6b7ndpLk042zRT/K06M3FjvjLIyDtl4UtH8hEtrPDpjkG/ot58MGm6CVQJHLoN1j3wOJPE5kNTnQPw9kM4zkJtnIGfPQGrvSK8cWLJsz2zFjq82rPhqz4avTuzY6sqKrViwVc8bTzyL8ccQogWjjwHgDfyxi9fTetltAAAAAElFTkSuQmCC",
    preserveAspectRatio: "none",
    id: "img78"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip79"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 723,
    y: 590,
    width: 259,
    height: 14
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-215 0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    xlinkHref: "#img0",
    transform: "translate(229 7)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)"
  }, /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    xlinkHref: "#img2",
    transform: "translate(293 70)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5)"
  }, /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    xlinkHref: "#img4",
    transform: "translate(706 72)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip7)"
  }, /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    xlinkHref: "#img6",
    transform: "translate(681 75)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip9)"
  }, /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    xlinkHref: "#img8",
    transform: "translate(886 75)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip11)"
  }, /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    xlinkHref: "#img10",
    transform: "translate(496 76)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M440.327 75.8171C443.699 75.0868 445.327 76.392 445.214 79.7289 443.26 79.7289 441.306 79.7289 439.348 79.7289 439.286 78.2994 439.609 76.998 440.327 75.8171Z",
    fill: "#03466E",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.949 81.6829C196.949 111.358 196.949 141.033 196.949 170.708 158.18 170.708 119.407 170.708 80.6379 170.708 80.6379 141.033 80.6379 111.358 80.6379 81.6829 119.407 81.6829 158.18 81.6829 196.949 81.6829Z",
    fill: "#F5F6F6",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.465 82.6619C614.78 81.6907 622.273 81.3683 629.946 81.6829 630.179 82.9493 629.852 83.9244 628.971 84.6197 622.203 82.7007 615.036 82.0481 607.465 82.6619Z",
    fill: "#9AAEB9",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.833 81.6829C636.138 81.6829 637.439 81.6829 638.744 81.6829 639.071 84.6197 637.765 85.925 634.833 85.5987 634.833 84.2934 634.833 82.9882 634.833 81.6829Z",
    fill: "#E8EDEF",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.599 81.6829C428.599 82.0092 428.599 82.3355 428.599 82.6619 423.712 82.6619 418.826 82.6619 413.939 82.6619 413.939 109.4 413.939 136.142 413.939 162.88 432.834 162.88 451.733 162.88 470.628 162.88 470.628 136.142 470.628 109.4 470.628 82.6619 465.741 82.6619 460.854 82.6619 455.967 82.6619 455.967 82.3355 455.967 82.0092 455.967 81.6829 461.18 81.6829 466.393 81.6829 471.607 81.6829 471.607 109.078 471.607 136.468 471.607 163.859 452.055 163.859 432.507 163.859 412.96 163.859 412.96 136.468 412.96 109.078 412.96 81.6829 418.173 81.6829 423.386 81.6829 428.599 81.6829Z",
    fill: "#7993AA",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.599 82.6619C428.599 84.6197 428.599 86.5776 428.599 88.5316 437.721 88.5316 446.846 88.5316 455.967 88.5316 455.967 86.5776 455.967 84.6197 455.967 82.6619 460.854 82.6619 465.741 82.6619 470.628 82.6619 470.628 109.4 470.628 136.142 470.628 162.88 451.733 162.88 432.834 162.88 413.939 162.88 413.939 136.142 413.939 109.4 413.939 82.6619 418.826 82.6619 423.712 82.6619 428.599 82.6619Z",
    fill: "#FBFBFC",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.465 82.6619C615.036 82.0481 622.203 82.7007 628.971 84.6197 621.403 85.2374 614.232 84.5848 607.465 82.6619Z",
    fill: "#EAEEF0",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.804 90.4895C609.745 90.4895 626.69 90.4895 643.631 90.4895 643.631 115.922 643.631 141.359 643.631 166.792 626.69 166.792 609.745 166.792 592.804 166.792 592.804 141.359 592.804 115.922 592.804 90.4895Z",
    fill: "#FDFEFE",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.804 90.4895C609.901 89.5144 627.168 89.1881 644.606 89.5105 644.933 115.441 644.606 141.2 643.631 166.792 643.631 141.359 643.631 115.922 643.631 90.4895 626.69 90.4895 609.745 90.4895 592.804 90.4895Z",
    fill: "#7C96A4",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.949 81.6829C158.18 81.6829 119.407 81.6829 80.6379 81.6829 80.6379 111.358 80.6379 141.033 80.6379 170.708 79.6629 140.874 79.3366 110.872 79.659 80.7079 118.921 80.3816 158.021 80.7079 196.949 81.6829Z",
    fill: "#90A4B6",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.4999 90.4895C121.038 90.4895 155.573 90.4895 190.108 90.4895 190.108 95.3803 190.108 100.271 190.108 105.162 155.573 105.162 121.038 105.162 86.4999 105.162 86.4999 100.271 86.4999 95.3803 86.4999 90.4895Z",
    fill: "#043159",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.719 94.4013C639.719 110.379 639.719 126.36 639.719 142.338 625.059 142.338 610.398 142.338 595.737 142.338 595.737 126.36 595.737 110.379 595.737 94.4013 610.398 94.4013 625.059 94.4013 639.719 94.4013Z",
    fill: "#05C0CF",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.666 97.3381C427.158 97.3537 427.648 98.0063 427.131 99.2921 423.802 103.363 421.848 103.037 421.269 98.3171 423.141 99.7 424.606 99.3737 425.666 97.3381Z",
    fill: "#C3DB6A",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.645 111.032C427.644 111.42 427.807 112.073 427.131 112.989 425.83 114.295 424.524 115.6 423.223 116.901 422.225 116.066 421.409 115.087 420.78 113.968 421.537 112.784 422.349 112.784 423.223 113.968 424.707 113.32 425.845 112.341 426.645 111.032Z",
    fill: "#C3DB6B",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip13)"
  }, /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    xlinkHref: "#img12",
    transform: "translate(802 118)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip15)"
  }, /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    xlinkHref: "#img14",
    transform: "translate(824 118)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M86.4999 118.859C97.2721 118.533 108.025 118.859 118.758 119.838 113.382 120.164 108.005 120.491 102.629 120.817 96.8836 120.809 91.5111 120.161 86.4999 118.859Z",
    fill: "#C6C6C6",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.645 118.859C133.438 118.533 143.212 118.859 152.967 119.838 148.08 120.164 143.193 120.491 138.306 120.817 133.046 120.809 128.159 120.157 123.645 118.859Z",
    fill: "#C6C6C6",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.854 118.859C168.626 118.533 179.375 118.859 190.108 119.838 184.732 120.164 179.355 120.491 173.979 120.817 168.237 120.809 162.861 120.161 157.854 118.859Z",
    fill: "#C7C7C7",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.748 119.838C211.761 119.823 214.531 122.756 214.053 128.641 209.636 134.079 205.724 133.753 202.325 127.662 201.673 126.36 201.673 125.055 202.325 123.75 203.669 122.573 204.811 121.268 205.748 119.838Z",
    fill: "#EEF1F4",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.4999 122.771C97.2721 122.449 108.025 122.771 118.758 123.75 113.382 124.076 108.005 124.403 102.629 124.729 96.8836 124.725 91.5111 124.072 86.4999 122.771Z",
    fill: "#CCCCCC",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.645 122.771C133.438 122.449 143.212 122.771 152.967 123.75 148.08 124.076 143.193 124.403 138.306 124.729 133.046 124.721 128.159 124.072 123.645 122.771Z",
    fill: "#CCCCCC",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.854 122.771C168.299 122.449 178.726 122.771 189.129 123.75 183.92 124.076 178.706 124.403 173.493 124.729 167.911 124.725 162.698 124.072 157.854 122.771Z",
    fill: "#CCCCCC",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.666 124.729C427.158 124.744 427.648 125.397 427.131 126.683 423.802 130.754 421.848 130.428 421.269 125.708 423.141 127.091 424.606 126.765 425.666 124.729Z",
    fill: "#C1D966",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.532 126.683C442.301 126.36 453.053 126.687 463.787 127.662 458.41 127.988 453.034 128.314 447.658 128.641 441.916 128.637 436.54 127.984 431.532 126.683Z",
    fill: "#97A9BC",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip17)"
  }, /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    xlinkHref: "#img16",
    transform: "translate(809 138)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip19)"
  }, /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    xlinkHref: "#img18",
    transform: "translate(536 139)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M86.4999 141.359C97.2721 141.033 108.025 141.359 118.758 142.338 113.382 142.664 108.005 142.991 102.629 143.317 96.8836 143.309 91.5111 142.661 86.4999 141.359Z",
    fill: "#CECFCE",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.645 141.359C133.438 141.033 143.212 141.359 152.967 142.338 148.08 142.664 143.193 142.991 138.306 143.317 133.046 143.309 128.159 142.657 123.645 141.359Z",
    fill: "#CECFCE",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.854 141.359C168.299 141.033 178.726 141.359 189.129 142.338 183.92 142.664 178.706 142.991 173.493 143.317 167.911 143.309 162.698 142.657 157.854 141.359Z",
    fill: "#CECFCE",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.645 137.447C427.174 137.506 427.5 137.832 427.62 138.422 426.307 141.596 424.19 142.575 421.269 141.359 420.966 139.39 421.619 139.063 423.223 140.38 424.707 139.732 425.845 138.753 426.645 137.447Z",
    fill: "#C1D964",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.532 140.38C442.301 140.054 453.053 140.38 463.787 141.359 458.41 141.686 453.034 142.012 447.658 142.338 441.916 142.33 436.54 141.682 431.532 140.38Z",
    fill: "#7691A9",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.719 94.4013C640.694 110.534 641.021 126.838 640.698 143.317 625.54 143.639 610.553 143.313 595.737 142.338 610.398 142.338 625.059 142.338 639.719 142.338 639.719 126.36 639.719 110.379 639.719 94.4013Z",
    fill: "#7DDDE6",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.719 146.25C639.719 152.12 639.719 157.989 639.719 163.859 625.059 163.859 610.398 163.859 595.737 163.859 595.737 157.989 595.737 152.12 595.737 146.25 610.398 146.25 625.059 146.25 639.719 146.25Z",
    fill: "#BBD657",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.129 149.183C189.129 152.12 189.129 155.053 189.129 157.989 154.921 157.989 120.712 157.989 86.4999 157.989 86.4999 155.053 86.4999 152.12 86.4999 149.183 120.712 149.183 154.921 149.183 189.129 149.183Z",
    fill: "#A0A0A0",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.331 162.88C307.724 164.186 305.117 164.186 302.511 162.88 301.209 160.27 301.209 157.663 302.511 155.053 305.117 153.751 307.724 153.751 310.331 155.053 311.632 157.663 311.632 160.27 310.331 162.88Z",
    fill: "#FAFCF3",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.129 149.183C190.088 152.24 190.415 155.503 190.108 158.968 155.406 159.291 120.871 158.965 86.4999 157.989 120.712 157.989 154.921 157.989 189.129 157.989 189.129 155.053 189.129 152.12 189.129 149.183Z",
    fill: "#C5C5C5",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.444 157.989C306.594 157.776 307.569 158.102 308.377 158.968 306.858 160.239 305.883 159.912 305.444 157.989Z",
    fill: "#C2DA68",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.331 162.88C311.379 161.746 312.518 161.746 313.753 162.88 314.969 160.849 316.76 159.87 319.129 159.947 319.129 160.922 319.129 161.901 319.129 162.88 323.772 160.783 325.399 162.088 324.016 166.792 324.82 167.658 325.799 167.985 326.945 167.771 327.12 170.199 326.141 171.994 324.016 173.151 325.578 176.64 324.603 177.782 321.083 176.578 319.665 178.59 317.708 179.569 315.218 179.511 315.431 178.361 315.105 177.382 314.239 176.578 313.03 177.304 311.729 177.63 310.331 177.553 310.331 175.599 310.331 173.641 310.331 171.683 309.352 171.683 308.377 171.683 307.398 171.683 307.324 169.313 308.303 167.522 310.331 166.303 309.2 165.071 309.2 163.929 310.331 162.88Z",
    fill: "#FBFCF5",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.719 146.25C640.691 152.26 641.013 158.456 640.698 164.838 625.54 165.161 610.553 164.834 595.737 163.859 610.398 163.859 625.059 163.859 639.719 163.859 639.719 157.989 639.719 152.12 639.719 146.25Z",
    fill: "#E2EEB8",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.218 166.792C320.738 166.61 322.043 168.727 319.129 173.151 314.526 173.233 313.221 171.112 315.218 166.792Z",
    fill: "#C0D861",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.444 173.641C614.959 173.641 621.477 173.641 627.992 173.641 627.992 175.599 627.992 177.553 627.992 179.511 621.477 179.511 614.959 179.511 608.444 179.511 608.444 177.553 608.444 175.599 608.444 173.641Z",
    fill: "#FEFFFE",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip21)"
  }, /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    xlinkHref: "#img20",
    transform: "translate(670 178)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip23)"
  }, /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    xlinkHref: "#img22",
    transform: "translate(920 195)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip25)"
  }, /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    xlinkHref: "#img24",
    transform: "translate(563 199)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip27)"
  }, /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    xlinkHref: "#img26",
    transform: "translate(920 204)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip29)"
  }, /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    xlinkHref: "#img28",
    transform: "translate(803 214)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip31)"
  }, /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    xlinkHref: "#img30",
    transform: "translate(292 214)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip33)"
  }, /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    xlinkHref: "#img32",
    transform: "translate(563 215)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip35)"
  }, /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    xlinkHref: "#img34",
    transform: "translate(920 215)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip37)"
  }, /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    xlinkHref: "#img36",
    transform: "translate(920 225)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M93.3447 226.468C99.2455 225.862 102.505 228.469 103.119 234.292 104.094 234.292 105.073 234.292 106.051 234.292 107.52 239.171 108.658 244.066 109.47 248.968 104.008 251.606 98.3054 253.564 92.3658 254.838 91.3674 250.367 90.0622 245.962 88.4578 241.63 88.8968 240.372 89.5494 239.233 90.4118 238.208 88.3917 233.333 89.3707 229.417 93.3447 226.468Z",
    fill: "#FBFEFE",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.3447 229.401C97.8898 228.729 100.496 230.687 101.165 235.271 98.422 236.837 95.489 237.816 92.3658 238.208 90.8002 234.98 91.1266 232.043 93.3447 229.401Z",
    fill: "#2DC5D3",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.023 233.317C543.286 235.287 546.219 237.734 548.822 240.651 546.989 242.318 545.361 244.113 543.935 246.032 542.451 246.043 541.309 246.696 540.513 247.989 540.023 243.11 539.86 238.216 540.023 233.317Z",
    fill: "#FDFEFB",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip39)"
  }, /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    xlinkHref: "#img38",
    transform: "translate(920 235)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M541.002 231.359C544.906 235.263 549.145 238.849 553.709 242.12 558.06 238.973 561.972 235.384 565.437 231.359 566.039 231.468 566.528 231.794 566.905 232.338 567.554 237.882 567.554 243.425 566.905 248.968 566.528 249.512 566.039 249.839 565.437 249.947 563.809 247.989 562.178 246.032 560.55 244.078 559.043 243.876 557.737 243.227 556.642 242.12 554.466 244.489 552.182 244.489 549.797 242.12 548.076 243.86 546.118 245.161 543.935 246.032 545.361 244.113 546.989 242.318 548.822 240.651 546.219 237.734 543.286 235.287 540.023 233.317 539.856 232.346 540.183 231.693 541.002 231.359Z",
    fill: "#CCE07F",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.55 244.078C559.777 242.811 558.802 241.669 557.617 240.651 560.678 238.569 563.448 236.126 565.926 233.317 566.579 238.208 566.579 243.099 565.926 247.989 564.508 246.067 562.718 244.765 560.55 244.078Z",
    fill: "#FDFEFB",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.002 231.359C549.148 231.359 557.291 231.359 565.437 231.359 561.972 235.384 558.06 238.973 553.709 242.12 549.145 238.849 544.906 235.263 541.002 231.359Z",
    fill: "#FDFEFA",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.55 244.078C562.178 246.032 563.809 247.989 565.437 249.947 557.287 250.107 549.141 249.947 541.002 249.458 542.183 248.44 543.162 247.298 543.935 246.032 546.118 245.161 548.076 243.86 549.797 242.12 552.182 244.489 554.466 244.489 556.642 242.12 557.737 243.227 559.043 243.876 560.55 244.078Z",
    fill: "#FEFEFC",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.21 243.099C340.713 242.617 409.129 243.106 477.468 244.567 477.958 245.053 478.447 245.542 478.937 246.032 479.586 287.772 479.586 329.509 478.937 371.25 478.121 372.066 477.305 372.882 476.493 373.697 408.073 374.35 339.652 374.35 271.235 373.697 270.058 372.812 269.246 371.673 268.792 370.271 268.139 329.183 268.139 288.099 268.792 247.011 269.464 245.2 270.606 243.895 272.21 243.099Z",
    fill: "#FBFBFB",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.264 246.032C621.811 246.385 622.46 248.343 618.218 251.901 615.394 250.596 614.741 248.638 616.264 246.032Z",
    fill: "#214961",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.264 255.817C620.156 255.941 621.461 257.736 620.172 261.197 615.51 261.99 614.205 260.195 616.264 255.817Z",
    fill: "#274E65",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.963 262.662C343.238 262.662 403.512 262.662 463.787 262.662 463.787 271.795 463.787 280.924 463.787 290.053 403.512 290.053 343.238 290.053 282.963 290.053 282.963 280.924 282.963 271.795 282.963 262.662Z",
    fill: "#0DC0D0",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip41)"
  }, /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    xlinkHref: "#img40",
    transform: "translate(389 264)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip43)"
  }, /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    xlinkHref: "#img42",
    transform: "translate(486 264)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M616.264 266.578C619.818 265.828 621.287 267.133 620.661 270.489 616.178 272.362 614.714 271.057 616.264 266.578Z",
    fill: "#1A455D",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.264 276.359C619.818 275.613 621.287 276.915 620.661 280.271 616.178 282.143 614.714 280.838 616.264 276.359Z",
    fill: "#1A445D",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip45)"
  }, /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    xlinkHref: "#img44",
    transform: "translate(413 285)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M616.264 286.141C620.7 286.448 621.679 288.242 619.197 291.521 615.32 291.638 614.345 289.843 616.264 286.141Z",
    fill: "#224A62",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.037 322.338C323.037 313.205 323.037 304.076 323.037 294.947 310.004 294.947 296.971 294.947 283.942 294.947 283.942 304.076 283.942 313.205 283.942 322.338 282.967 313.058 282.645 303.602 282.963 293.968 296.645 293.968 310.331 293.968 324.016 293.968 324.335 303.602 324.009 313.058 323.037 322.338Z",
    fill: "#DCE9A7",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.868 322.338C416.868 313.205 416.868 304.076 416.868 294.947 403.838 294.947 390.805 294.947 377.772 294.947 377.772 304.076 377.772 313.205 377.772 322.338 376.801 313.058 376.475 303.602 376.793 293.968 390.479 293.968 404.165 293.968 417.847 293.968 418.165 303.602 417.843 313.058 416.868 322.338Z",
    fill: "#DBE9A4",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.037 322.338C310.004 322.338 296.971 322.338 283.942 322.338 283.942 313.205 283.942 304.076 283.942 294.947 296.971 294.947 310.004 294.947 323.037 294.947 323.037 304.076 323.037 313.205 323.037 322.338Z",
    fill: "#BAD654",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.878 293.968C343.238 293.968 356.593 293.968 369.953 293.968 369.953 303.424 369.953 312.879 369.953 322.338 356.593 322.338 343.238 322.338 329.878 322.338 329.878 312.879 329.878 303.424 329.878 293.968Z",
    fill: "#BCD658",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.868 322.338C403.838 322.338 390.805 322.338 377.772 322.338 377.772 313.205 377.772 304.076 377.772 294.947 390.805 294.947 403.838 294.947 416.868 294.947 416.868 304.076 416.868 313.205 416.868 322.338Z",
    fill: "#BAD654",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.712 293.968C437.068 293.968 450.427 293.968 463.787 293.968 463.787 303.424 463.787 312.879 463.787 322.338 450.427 322.338 437.068 322.338 423.712 322.338 423.712 312.879 423.712 303.424 423.712 293.968Z",
    fill: "#BCD658",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.264 295.922C620.7 296.233 621.679 298.028 619.197 301.303 615.32 301.419 614.345 299.624 616.264 295.922Z",
    fill: "#224A62",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.041 306.683C499.596 305.937 501.064 307.242 500.439 310.599 495.956 312.471 494.491 311.166 496.041 306.683Z",
    fill: "#1E465F",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.815 306.683C511.362 307.036 512.015 308.994 507.769 312.553 504.945 311.247 504.292 309.29 505.815 306.683Z",
    fill: "#204961",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.589 306.683C519.672 306.03 520.973 307.499 519.497 311.088 518.234 311.566 516.929 311.729 515.589 311.578 515.589 309.946 515.589 308.314 515.589 306.683Z",
    fill: "#113E58",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.341 306.683C529.675 306.57 530.976 308.202 530.249 311.578 528.622 311.578 526.994 311.578 525.363 311.578 525.23 309.822 525.557 308.194 526.341 306.683Z",
    fill: "#103D57",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.115 306.683C541.663 307.036 542.315 308.994 538.069 312.553 535.245 311.247 534.593 309.29 536.115 306.683Z",
    fill: "#234A62",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.889 306.683C551.436 307.036 552.089 308.994 547.843 312.553 545.019 311.247 544.366 309.29 545.889 306.683Z",
    fill: "#214961",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.642 306.683C559.975 306.57 561.276 308.202 560.55 311.578 558.922 311.578 557.291 311.578 555.663 311.578 555.531 309.822 555.857 308.194 556.642 306.683Z",
    fill: "#113E57",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.416 306.683C569.749 306.57 571.05 308.202 570.324 311.578 568.696 311.578 567.068 311.578 565.437 311.578 565.305 309.822 565.631 308.194 566.416 306.683Z",
    fill: "#103E57",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.19 306.683C581.737 307.036 582.389 308.994 578.144 312.553 575.319 311.247 574.667 309.29 576.19 306.683Z",
    fill: "#214961",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.963 306.683C591.511 307.036 592.163 308.994 587.917 312.553 585.093 311.247 584.441 309.29 585.963 306.683Z",
    fill: "#224A62",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.716 306.683C600.049 306.57 601.351 308.202 600.624 311.578 598.996 311.578 597.365 311.578 595.737 311.578 595.605 309.822 595.931 308.194 596.716 306.683Z",
    fill: "#103E57",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.49 306.683C607.791 306.683 609.097 306.683 610.398 306.683 610.398 308.314 610.398 309.946 610.398 311.578 606.063 312.141 604.761 310.509 606.49 306.683Z",
    fill: "#113E58",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.264 306.683C617.565 306.683 618.87 306.683 620.172 306.683 620.172 308.314 620.172 309.946 620.172 311.578 615.836 312.141 614.535 310.509 616.264 306.683Z",
    fill: "#0F3E57",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.963 330.162C293.409 329.839 303.835 330.166 314.239 331.141 309.029 331.467 303.816 331.793 298.603 332.12 293.021 332.116 287.807 331.463 282.963 330.162Z",
    fill: "#CFCFCF",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.878 330.162C341.626 329.839 353.353 330.166 365.066 331.141 359.2 331.467 353.338 331.793 347.472 332.12 341.245 332.116 335.379 331.463 329.878 330.162Z",
    fill: "#CECFCE",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.793 330.162C387.239 329.839 397.666 330.166 408.073 331.141 402.86 331.467 397.646 331.793 392.433 332.12 386.851 332.116 381.638 331.463 376.793 330.162Z",
    fill: "#CFCFCF",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.963 334.078C292.108 333.751 301.233 334.078 310.331 335.053 305.77 335.379 301.209 335.705 296.645 336.032 291.711 336.024 287.151 335.375 282.963 334.078Z",
    fill: "#D5D5D5",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.878 334.078C339.027 333.751 348.148 334.078 357.246 335.053 352.685 335.379 348.125 335.705 343.564 336.032 338.627 336.024 334.066 335.375 329.878 334.078Z",
    fill: "#D5D5D5",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.793 334.078C389.193 333.751 401.574 334.078 413.939 335.053 407.746 335.379 401.554 335.705 395.366 336.032 388.813 336.028 382.624 335.379 376.793 334.078Z",
    fill: "#D5D5D5",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip47)"
  }, /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    xlinkHref: "#img46",
    transform: "translate(848 339)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M416.868 361.468C416.868 358.532 416.868 355.599 416.868 352.662 372.233 352.662 327.598 352.662 282.963 352.662 282.963 355.599 282.963 358.532 282.963 361.468 282.008 358.411 281.681 355.148 281.984 351.683 327.272 351.683 372.559 351.683 417.847 351.683 418.153 355.148 417.827 358.411 416.868 361.468Z",
    fill: "#C4C4C4",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.868 361.468C372.233 361.468 327.598 361.468 282.963 361.468 282.963 358.532 282.963 355.599 282.963 352.662 327.598 352.662 372.233 352.662 416.868 352.662 416.868 355.599 416.868 358.532 416.868 361.468Z",
    fill: "#A0A0A0",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.712 351.683C436.742 351.683 449.775 351.683 462.808 351.683 462.808 354.946 462.808 358.205 462.808 361.468 449.775 361.468 436.742 361.468 423.712 361.468 423.712 358.205 423.712 354.946 423.712 351.683Z",
    fill: "#A2A2A2",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip49)"
  }, /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    xlinkHref: "#img48",
    transform: "translate(782 364)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip51)"
  }, /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    xlinkHref: "#img50",
    transform: "translate(801 365)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M528.295 365.38C531.963 367.579 535.222 370.353 538.069 373.697 534.993 375.958 532.064 378.402 529.274 381.032 528.299 375.857 527.973 370.64 528.295 365.38Z",
    fill: "#32C5D3",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.578 362.447C608.654 363.329 614.356 365.287 619.682 368.317 620.335 369.945 620.335 371.576 619.682 373.208 616.481 382.007 613.385 390.813 610.398 399.62 604.796 400.21 599.583 399.068 594.758 396.197 593.084 395.436 592.105 394.131 591.829 392.282 595.283 382.271 598.868 372.326 602.578 362.447Z",
    fill: "#F5FCFD",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.603 368.317C606.684 370.337 611.897 371.969 617.239 373.208 616.571 377.827 614.943 382.065 612.352 385.922 607.314 384.081 602.427 381.96 597.691 379.567 599.292 375.908 600.593 372.155 601.603 368.317Z",
    fill: "#22C3D2",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip53)"
  }, /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    xlinkHref: "#img52",
    transform: "translate(425 382)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip55)"
  }, /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    xlinkHref: "#img54",
    transform: "translate(313 390)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip57)"
  }, /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    xlinkHref: "#img56",
    transform: "translate(335 390)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M596.716 383.968C599.863 385.46 602.955 387.092 606 388.859 607.628 388.859 609.26 388.859 610.887 388.859 611.435 394.624 608.992 396.582 603.557 394.729 600.154 393.843 597.221 392.212 594.758 389.838 595.415 387.849 596.067 385.895 596.716 383.968Z",
    fill: "#A7E7ED",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.437 394.729C290.13 394.729 317.824 394.729 345.518 394.729 345.829 399.484 345.502 404.052 344.539 408.422 344.539 404.184 344.539 399.946 344.539 395.708 317.004 396.03 289.637 395.704 262.437 394.729Z",
    fill: "#BCC8D2",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip59)"
  }, /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    xlinkHref: "#img58",
    transform: "translate(337 411)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M269.277 419.183C281.965 417.707 288.32 423.25 288.34 435.817 284.4 445.692 277.396 448.788 267.323 445.109 257.697 435.51 258.346 426.867 269.277 419.183Z",
    fill: "#133960",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.235 422.12C282.66 422.302 286.735 427.846 283.453 438.75 276.48 445.638 270.287 444.985 264.88 436.792 264.227 433.859 264.227 430.922 264.88 427.989 266.896 425.802 269.013 423.848 271.235 422.12Z",
    fill: "#DEE5E9",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.164 425.053C278.57 424.812 281.503 426.77 282.963 430.922 282.474 431.249 281.984 431.575 281.499 431.901 279.125 429.357 276.682 427.073 274.164 425.053Z",
    fill: "#1E4066",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.461 443.641C263.384 444.934 265.342 446.24 267.323 447.553 264.74 451.251 261.807 454.673 258.529 457.828 254.632 458.158 253.164 456.363 254.127 452.447 256.582 449.479 259.026 446.547 261.461 443.641Z",
    fill: "#0C345C",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip61)"
  }, /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    xlinkHref: "#img60",
    transform: "translate(675 443)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip63)"
  }, /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    xlinkHref: "#img62",
    transform: "translate(681 446)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip65)"
  }, /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    xlinkHref: "#img64",
    transform: "translate(705 456)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip67)"
  }, /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    xlinkHref: "#img66",
    transform: "translate(690 458)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip69)"
  }, /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    xlinkHref: "#img68",
    transform: "translate(697 459)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M471.607 462.229C527.32 462.066 583.03 462.229 638.744 462.718 639.234 463.208 639.719 463.697 640.209 464.183 640.862 500.707 640.862 537.23 640.209 573.75 639.719 574.239 639.234 574.729 638.744 575.218 611.051 575.382 583.357 575.545 555.663 575.708 527.235 575.863 498.892 575.374 470.628 574.239 469.489 537.623 469.33 500.94 470.138 464.183 470.841 463.651 471.327 463.002 471.607 462.229Z",
    fill: "#F7F7F8",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip71)"
  }, /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    xlinkHref: "#img70",
    transform: "translate(682 464)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M105.073 467.12C134.72 467.12 164.368 467.12 194.016 467.12 194.016 505.924 194.016 544.728 194.016 583.532 164.368 583.532 134.72 583.532 105.073 583.532 105.073 544.728 105.073 505.924 105.073 467.12Z",
    fill: "#F6F6F7",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.154 476.901C162.414 476.901 136.674 476.901 110.938 476.901 110.938 480.164 110.938 483.424 110.938 486.683 109.979 483.299 109.653 479.71 109.959 475.922 136.193 475.6 162.255 475.926 188.154 476.901Z",
    fill: "#C7D1DA",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.154 476.901C188.154 480.164 188.154 483.424 188.154 486.683 162.414 486.683 136.674 486.683 110.938 486.683 110.938 483.424 110.938 480.164 110.938 476.901 136.674 476.901 162.414 476.901 188.154 476.901Z",
    fill: "#012E58",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.422 482.771C529.597 482.771 579.771 482.771 629.946 482.771 629.946 488.641 629.946 494.511 629.946 500.38 579.771 500.38 529.597 500.38 479.422 500.38 479.422 494.511 479.422 488.641 479.422 482.771Z",
    fill: "#09325B",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.034 498.422C163.082 498.1 176.115 498.426 189.129 499.401 182.614 499.728 176.1 500.054 169.581 500.38 162.705 500.376 156.191 499.724 150.034 498.422Z",
    fill: "#CBCBCB",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.034 502.338C162.756 502.012 175.463 502.338 188.154 503.317 181.799 503.639 175.447 503.966 169.092 504.292 162.379 504.292 156.028 503.639 150.034 502.338Z",
    fill: "#D1D1D1",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.422 505.271C529.597 505.271 579.771 505.271 629.946 505.271 629.946 508.208 629.946 511.141 629.946 514.078 579.771 514.078 529.597 514.078 479.422 514.078 479.422 511.141 479.422 508.208 479.422 505.271Z",
    fill: "#A3A3A3",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.878 515.053C351.419 514.342 362.331 524.776 362.622 546.359 378.545 552.73 382.78 563.817 375.329 579.62 372.307 583.951 368.236 586.721 363.112 587.933 337.372 588.586 311.632 588.586 285.896 587.933 271.577 580.684 267.832 569.76 274.654 555.162 278.282 550.337 283.006 547.404 288.829 546.359 288.841 534.441 294.706 529.387 306.423 531.197 308.21 531.461 309.674 532.277 310.82 533.641 312.65 529.162 315.093 525.083 318.15 521.412 321.717 518.491 325.625 516.37 329.878 515.053Z",
    fill: "#BBD657",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.034 517.01C163.082 516.684 176.115 517.01 189.129 517.989 182.614 518.316 176.1 518.642 169.581 518.968 162.705 518.965 156.191 518.312 150.034 517.01Z",
    fill: "#C7C7C7",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.422 518.968C495.078 518.642 510.713 518.968 526.341 519.947 518.522 520.27 510.702 520.6 502.882 520.922 494.709 520.922 486.889 520.27 479.422 518.968Z",
    fill: "#CDCDCD",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.228 518.968C546.88 518.642 562.519 518.968 578.144 519.947 570.324 520.27 562.504 520.6 554.684 520.922 546.511 520.922 538.695 520.27 531.228 518.968Z",
    fill: "#CDCDCD",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.03 518.968C598.682 518.642 614.321 518.968 629.946 519.947 622.126 520.27 614.31 520.6 606.49 520.922 598.317 520.922 590.497 520.27 583.03 518.968Z",
    fill: "#CDCDCD",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.938 491.578C110.938 501.686 110.938 511.793 110.938 521.901 122.992 521.901 135.047 521.901 147.101 521.901 147.101 511.793 147.101 501.686 147.101 491.578 148.072 501.837 148.398 512.271 148.08 522.88 135.373 522.88 122.666 522.88 109.959 522.88 109.641 512.271 109.967 501.837 110.938 491.578Z",
    fill: "#84DFE7",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.938 491.578C122.992 491.578 135.047 491.578 147.101 491.578 147.101 501.686 147.101 511.793 147.101 521.901 135.047 521.901 122.992 521.901 110.938 521.901 110.938 511.793 110.938 501.686 110.938 491.578Z",
    fill: "#05C0CF",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.034 520.922C162.756 520.6 175.463 520.926 188.154 521.901 181.799 522.228 175.447 522.554 169.092 522.88 162.379 522.876 156.028 522.224 150.034 520.922Z",
    fill: "#D1D1D1",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.422 522.88C495.078 522.554 510.713 522.88 526.341 523.859 518.522 524.185 510.702 524.512 502.882 524.838 494.709 524.834 486.889 524.182 479.422 522.88Z",
    fill: "#D3D3D3",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.228 522.88C546.88 522.554 562.519 522.88 578.144 523.859 570.324 524.185 562.504 524.512 554.684 524.838 546.511 524.834 538.695 524.182 531.228 522.88Z",
    fill: "#D3D3D3",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.03 522.88C598.682 522.554 614.321 522.88 629.946 523.859 622.126 524.185 614.31 524.512 606.49 524.838 598.317 524.834 590.497 524.182 583.03 522.88Z",
    fill: "#D3D3D3",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.938 537.553C123.334 537.23 135.715 537.557 148.08 538.532 141.888 538.858 135.699 539.184 129.507 539.51 122.954 539.507 116.765 538.854 110.938 537.553Z",
    fill: "#CDCDCD",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.422 537.553C495.078 537.23 510.713 537.557 526.341 538.532 518.522 538.858 510.702 539.184 502.882 539.51 494.709 539.51 486.889 538.858 479.422 537.553Z",
    fill: "#CDCDCD",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.228 537.553C546.88 537.23 562.519 537.557 578.144 538.532 570.324 538.858 562.504 539.184 554.684 539.51 546.511 539.51 538.695 538.858 531.228 537.553Z",
    fill: "#CDCDCD",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.03 537.553C598.682 537.23 614.321 537.557 629.946 538.532 622.126 538.858 614.31 539.184 606.49 539.51 598.317 539.51 590.497 538.858 583.03 537.553Z",
    fill: "#CDCDCD",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.264 539.51C320.788 539.375 323.884 542.964 322.548 550.271 317.502 555.714 312.941 555.387 308.866 549.292 308.213 547.664 308.213 546.033 308.866 544.401 310.199 542.579 311.667 540.952 313.264 539.51Z",
    fill: "#FCFDF8",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.79 539.51C340.452 539.495 343.548 542.754 343.074 549.292 338.996 555.387 334.435 555.714 329.389 550.271 328.192 545.505 329.661 541.915 333.79 539.51Z",
    fill: "#FCFDF9",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.938 541.468C123.334 541.142 135.715 541.468 148.08 542.447 141.888 542.77 135.699 543.1 129.507 543.422 122.954 543.419 116.765 542.77 110.938 541.468Z",
    fill: "#D3D3D3",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.422 541.468C495.078 541.142 510.713 541.468 526.341 542.447 518.522 542.77 510.702 543.1 502.882 543.422 494.709 543.422 486.889 542.77 479.422 541.468Z",
    fill: "#D3D3D3",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.228 541.468C546.88 541.142 562.519 541.468 578.144 542.447 570.324 542.77 562.504 543.1 554.684 543.422 546.511 543.422 538.695 542.77 531.228 541.468Z",
    fill: "#D3D3D3",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.03 541.468C598.682 541.142 614.321 541.468 629.946 542.447 622.126 542.77 614.31 543.1 606.49 543.422 598.317 543.422 590.497 542.77 583.03 541.468Z",
    fill: "#D3D3D3",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip73)"
  }, /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    xlinkHref: "#img72",
    transform: "translate(456 543)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip75)"
  }, /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    xlinkHref: "#img74",
    transform: "translate(475 543)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip77)"
  }, /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    xlinkHref: "#img76",
    transform: "translate(494 543)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M309.352 555.162C312.953 555.003 316.534 555.166 320.104 555.651 318.116 557.901 317.789 560.348 319.129 562.989 315.905 565.856 314.604 569.446 315.218 573.75 311.263 574.092 307.514 573.439 303.979 571.792 301.982 564.8 303.773 559.256 309.352 555.162Z",
    fill: "#FDFEFB",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.878 556.141C344.353 552.206 350.215 557.586 347.472 572.282 343.339 573.544 339.1 574.034 334.765 573.75 335.589 569.333 334.283 565.744 330.857 562.989 332.399 560.297 332.073 558.017 329.878 556.141Z",
    fill: "#FDFEFB",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.938 556.141C123.334 555.818 135.715 556.141 148.08 557.12 141.888 557.446 135.699 557.772 129.507 558.099 122.954 558.095 116.765 557.442 110.938 556.141Z",
    fill: "#C9C9C9",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.013 526.792C151.013 536.9 151.013 547.012 151.013 557.12 163.393 557.12 175.773 557.12 188.154 557.12 188.154 547.012 188.154 536.9 188.154 526.792 189.125 537.052 189.451 547.486 189.129 558.099 176.1 558.099 163.067 558.099 150.034 558.099 149.715 547.486 150.041 537.052 151.013 526.792Z",
    fill: "#D7E79C",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.013 526.792C163.393 526.792 175.773 526.792 188.154 526.792 188.154 536.9 188.154 547.012 188.154 557.12 175.773 557.12 163.393 557.12 151.013 557.12 151.013 547.012 151.013 536.9 151.013 526.792Z",
    fill: "#BBD656",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.129 565.922C189.129 564.947 189.129 563.968 189.129 562.989 163.393 562.989 137.653 562.989 111.913 562.989 111.913 563.968 111.913 564.947 111.913 565.922 111.001 564.877 110.674 563.576 110.938 562.01 137.327 562.01 163.719 562.01 190.108 562.01 190.368 563.576 190.042 564.877 189.129 565.922Z",
    fill: "#BFBFBF",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.129 565.922C163.393 565.922 137.653 565.922 111.913 565.922 111.913 564.947 111.913 563.968 111.913 562.989 137.653 562.989 163.393 562.989 189.129 562.989 189.129 563.968 189.129 564.947 189.129 565.922Z",
    fill: "#9FA09F",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.058 556.141C329.921 555.655 331.549 558.425 326.945 564.458 333.021 566.82 334.322 570.732 330.857 576.197 326.565 576.951 322.33 576.788 318.15 575.708 315.925 570.219 317.552 566.47 323.037 564.458 320.854 561.929 320.528 559.155 322.058 556.141Z",
    fill: "#FCFDF8",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.938 569.838C137.001 569.838 163.067 569.838 189.129 569.838 189.129 571.14 189.129 572.445 189.129 573.75 163.067 573.75 137.001 573.75 110.938 573.75 110.938 572.445 110.938 571.14 110.938 569.838Z",
    fill: "#A4A4A4",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.126 589.401C154.621 588.679 157.224 592.105 153.942 599.672 148.39 602.675 144.805 601.211 143.193 595.271 143.667 593.022 144.642 591.064 146.126 589.401Z",
    fill: "#F1F4F6",
    fillRule: "evenodd",
    transform: "matrix(1.14574 0 0 1 215.57 0)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip79)"
  }, /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    xlinkHref: "#img78",
    transform: "translate(723 590)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiemu);
export default __webpack_public_path__ + "static/media/SIEMU.69a551b39b642d9151e326d5a3fc55b4.svg";
export { ForwardRef as ReactComponent };